// JoinCoursesIJMForm.js - VERSÃO COMPLETA ATUALIZADA
import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
} from 'react';
import JumboContentLayout from '@jumbo/components/JumboContentLayout';
import useJumboTheme from '@jumbo/hooks/useJumboTheme';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Typography,
  useMediaQuery,
  Box,
  FormLabel,
  RadioGroup,
  Radio,
  Tooltip,
  Card,
  CardContent,
  Divider,
  Avatar,
  Alert,
  TextField,
  LinearProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import * as yup from 'yup';
import { Form, Formik } from 'formik';
import JumboTextField from '@jumbo/components/JumboFormik/JumboTextField';
import JumboSelectField from '@jumbo/components/JumboFormik/JumboSelectField';
import InputMask from 'react-input-mask';
import { ApiService } from 'app/servicesTwo/ApiService';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { updateInputValue } from '../../utils/appHelpers';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import axios from 'axios';
import {
  Visibility,
  VisibilityOff,
  School,
  ArrowBack,
  Groups,
  ExpandMore,
  FamilyRestroom,
} from '@mui/icons-material';
import { COUNTRIES } from '../../utils/constants/countries';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import { cpf } from 'cpf-cnpj-validator';
import authServices from 'app/servicesTwo/auth-services';
import { formatCPF } from '../login/Login';
import CheckboxSection from 'app/components/IJM/shared/CheckboxSection';
import ContatoCard from 'app/components/IJM/shared/ContatoCard';
import FormularioResponsavelNovo from 'app/components/IJM/forms/FormularioResponsavelNovo';
import FormularioCadastroResponsavelInicial from 'app/components/IJM/forms/FormularioCadastroResponsavelInicial';
import PopupEscolhaCadastro from 'app/components/IJM/dialogs/PopupEscolhaCadastro';
import PopupAdulto from 'app/components/IJM/dialogs/PopupAdulto';
import PopupMenorIdade from 'app/components/IJM/dialogs/PopupMenorIdade';
import DialogOpcoesEscolha from 'app/components/IJM/dialogs/DialogOpcoesEscolha';
import DialogSelecionarMenor from 'app/components/IJM/dialogs/DialogSelecionarMenor';

const JoinCoursesIJMForm = () => {
  const { theme } = useJumboTheme();
  const Swal = useSwalWrapper();
  const lg = useMediaQuery(theme.breakpoints.down('md'));

  const layoutOptions = React.useMemo(
    () => ({
      sidebar: {
        sx: {
          [theme.breakpoints.up('lg')]: {
            position: 'sticky',
            zIndex: 5,
            top: 96,
            minHeight: 'auto',
          },
          [theme.breakpoints.down('lg')]: {
            display: 'none',
          },
        },
      },
      wrapper: {
        sx: {
          alignItems: 'flex-start',
        },
      },
    }),
    [theme]
  );

  const initialValues = {
    nome: '',
    nome_social: '',
    data_nascimento: '',
    genero: '',
    cpf: '',
    rg: '',
    telefone: '05511',
    celular: '05511',
    celular_confirmacao: '',
    documento_internacional: '',
    email: '',
    email_confirmacao: '',
    pais: 'BR',
    bairro: '',
    cidade: '',
    estado: '',
    uf: '',
    numero: '',
    complemento: '',
    CEP: '',
    codigo_postal: '',
    senha: '',
    senhaConfirmacao: '',
    turmas_id: '',
    emailOrCpf: '',
  };

  // ✅ NOVO: Estados para dados do responsável (quando for novo)
  const initialValuesResponsavel = {
    nome_responsavel: '',
    data_nascimento_responsavel: '',
    cpf_responsavel: '',
    rg_responsavel: '',
    email_responsavel: '',
    email_responsavel_confirmacao: '',
    senha_responsavel: '',
    senha_responsavel_confirmacao: '',
    endereco_responsavel: '',
    numero_responsavel: '',
    complemento_responsavel: '',
    bairro_responsavel: '',
    cidade_responsavel: '',
    uf_responsavel: '',
    CEP_responsavel: '',
    pais_responsavel: 'BR',
    codigo_postal_responsavel: '',
    estado_responsavel: '',
    celular_responsavel: '05511',
    celular_responsavel_confirmacao: '',
    telefone_responsavel: '05511',
  };

  const [etapaAtual, setEtapaAtual] = useState('login'); // 'login' | 'confirmarAdulto' | 'escolha' | 'escolhaCadastro' | 'formulario'

  // Estados específicos para dados do menor
  const [mesmoEndereco, setMesmoEndereco] = useState(false);
  const [mesmoCelular, setMesmoCelular] = useState(false);
  const [mesmoTelefone, setMesmoTelefone] = useState(false);
  const [mesmoEmail, setMesmoEmail] = useState(false);
  const [enderecoConfirmado, setEnderecoConfirmado] = useState(false);
  const [mostrarSenhaResponsavel, setMostrarSenhaResponsavel] = useState(false);
  const [
    mostrarSenhaConfirmacaoResponsavel,
    setMostrarSenhaConfirmacaoResponsavel,
  ] = useState(false);

  const formikRef = useRef(null);
  // IDs de menores já matriculados nesta visita — evita reoferecer quem já foi feito
  const menoresJaMatriculadosRef = useRef([]);
  const { id, turmaId } = useParams();
  const [user, setUser] = useState(initialValues);
  const [isLoading, setIsLoading] = useState(false);
  const [isUserVerified, setIsUserVerified] = useState(false);
  const [nomeSocialObrigatorio, setNomeSocialObrigatorio] = useState(true);
  const [classes, setClasses] = useState([]);
  const [texts, setTexts] = useState('');
  const [confirmedUserData, setConfirmedUserData] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirmation, setShowPasswordConfirmation] =
    useState(false);
  const [userHasPassword, setUserHasPassword] = useState(false);

  const [isNewUser, setIsNewUser] = useState(false);
  const [courseIsClosed, setCourseIsClosed] = useState(false);
  const [isEnrollmentBlocked, setIsEnrollmentBlocked] = useState(false);
  const [verifyMask, setVerifyMask] = useState(false);
  const celularInputRef = useRef(null);

  // Estados específicos do fluxo IJM
  const [showIJMForm, setShowIJMForm] = useState(false);
  const [showIJMFormMenor, setShowIJMFormMenor] = useState(false);
  const [isResponsavel, setIsResponsavel] = useState(false);
  const [menoresVinculados, setMenoresVinculados] = useState([]);
  const [menorSelecionado, setMenorSelecionado] = useState(null);
  const [idade, setIdade] = useState(null);
  const [precisaResponsavel, setPrecisaResponsavel] = useState(false);
  const [escolhaCadastro, setEscolhaCadastro] = useState(null);

  const [isLoadingLogin, setIsLoadingLogin] = useState(false);
  const [isLoadingMenorId, setIsLoadingMenorId] = useState(null);

  // Estados para popups/dialogs
  const [showPopupEscolha, setShowPopupEscolha] = useState(false);
  const [showPopupAdulto, setShowPopupAdulto] = useState(false);
  const [showPopupMenorIdade, setShowPopupMenorIdade] = useState(false);
  // Estados para formulário do menor
  const [responsavelEncontrado, setResponsavelEncontrado] = useState(null);
  const [fotoMenor, setFotoMenor] = useState(null);
  const [previewFoto, setPreviewFoto] = useState(null);
  const [documentoTutela, setDocumentoTutela] = useState(null);
  const [documentoExistente, setDocumentoExistente] = useState(null);
  const [documentoRemovido, setDocumentoRemovido] = useState(false);
  const uploadTutelaRef = useRef(null);
  const [outrosDocumentos, setOutrosDocumentos] = useState([]);

  const [showDialogOpcoes, setShowDialogOpcoes] = useState(false);
  const [showDialogSelecionarMenor, setShowDialogSelecionarMenor] =
    useState(false);
  const [usuarioLogado, setUsuarioLogado] = useState(null);

  const navigate = useNavigate();

  // ✅ initialValuesIJM atualizado com campos do responsável
  const initialValuesIJM = {
    ...initialValues,
    ...initialValuesResponsavel, // ✅ Adiciona campos do responsável
    rg_menor: '',
    confirmar_endereco: false,
    grau_parentesco: '',
    deficiencias: [],
    outra_deficiencia: '',
    alergias: [],
    outra_alergia: '',
    problemas_saude: [],
    outro_problema_saude: '',
    transtornos: [],
    outro_transtorno: '',
    medicacao_continua: false,
    medicamentos: '',
    contato_emergencia_1_nome: '',
    contato_emergencia_1_parentesco: '',
    contato_emergencia_1_celular: '',
    contato_emergencia_2_nome: '',
    contato_emergencia_2_parentesco: '',
    contato_emergencia_2_celular: '',
    contato_emergencia_3_nome: '',
    contato_emergencia_3_parentesco: '',
    contato_emergencia_3_celular: '',
    autorizado_1_nome: '',
    autorizado_1_parentesco: '',
    autorizado_1_celular: '',
    autorizado_2_nome: '',
    autorizado_2_parentesco: '',
    autorizado_2_celular: '',
    autorizado_3_nome: '',
    autorizado_3_parentesco: '',
    autorizado_3_celular: '',
    pode_ir_sozinho: false,
  };

  // ✅ FUNÇÃO: Verificar se campo deve ser desabilitado
  const getCampoDisabled = (campoNome, isMenor = false) => {
    // Se for novo usuário, nada está desabilitado
    if (isNewUser) return false;

    if (isUserVerified) {
      if (etapaAtual === 'confirmarAdulto') {
        // Na confirmação do adulto, apenas nome e CPF ficam desabilitados
        if (campoNome === 'nome' || campoNome === 'cpf') return true;
        return false;
      }

      if (etapaAtual === 'formulario') {
        // Para menor existente sendo editado
        if (isMenor && menorSelecionado) {
          if (campoNome === 'cpf') return true; // CPF de menor existente não pode mudar
          return false; // Tudo mais pode ser editado
        }

        // Para adulto confirmado matriculando-se
        if (!showIJMFormMenor) {
          if (confirmedUserData) return true;
          return false;
        }

        // Para novo menor, nada está desabilitado
        return false;
      }
    }

    return false;
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowPasswordConfirmation = () =>
    setShowPasswordConfirmation((show) => !show);
  const handleClickShowSenhaResponsavel = () =>
    setMostrarSenhaResponsavel((show) => !show);
  const handleClickShowSenhaConfirmacaoResponsavel = () =>
    setMostrarSenhaConfirmacaoResponsavel((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseDownPasswordConfirmation = (event) => {
    event.preventDefault();
  };

  // ✅ FUNÇÃO: Preencher dados do responsável
  const preencherDadosResponsavel = (responsavel, setFieldValue) => {
    if (!responsavel) return;

    // Exibe os dados herdados no campo (desabilitado); o backend grava
    // sentinela/null, então não há poluição mesmo mostrando o valor.
    if (mesmoCelular && responsavel.celular) {
      setFieldValue('celular', responsavel.celular);
      setFieldValue('celular_confirmacao', responsavel.celular);
    }

    if (mesmoTelefone && responsavel.telefone) {
      setFieldValue('telefone', responsavel.telefone);
    }

    if (mesmoEmail && responsavel.email) {
      setFieldValue('email', responsavel.email);
      setFieldValue('email_confirmacao', responsavel.email);
    }

    if (mesmoEndereco) {
      setFieldValue('endereco', responsavel.endereco || '');
      setFieldValue('numero', responsavel.numero || '');
      setFieldValue('complemento', responsavel.complemento || '');
      setFieldValue('bairro', responsavel.bairro || '');
      setFieldValue('cidade', responsavel.cidade || '');
      setFieldValue('uf', responsavel.uf || '');
      setFieldValue('CEP', responsavel.CEP || '');
      setFieldValue('pais', responsavel.pais || 'BR');
      setEnderecoConfirmado(true);
    }
  };

  // ✅ Efeito para monitorar mudanças nos checkboxes
  useEffect(() => {
    if (responsavelEncontrado && formikRef.current) {
      const setFieldValue = formikRef.current.setFieldValue;
      preencherDadosResponsavel(responsavelEncontrado, setFieldValue);
    }
  }, [
    mesmoEndereco,
    mesmoCelular,
    mesmoTelefone,
    mesmoEmail,
    responsavelEncontrado,
  ]);

  const checkCep = async (e, setFieldValue) => {
    setIsLoading(true);
    const { value } = e.target;

    const cep = value.replace(/\D/g, '');
    await axios
      .get(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => {
        setFieldValue('endereco', res.data.logradouro);
        setFieldValue('bairro', res.data.bairro);
        setFieldValue('cidade', res.data.localidade);
        setFieldValue('uf', res.data.uf);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const checkCepResp = async (e, setFieldValue) => {
    setIsLoading(true);
    const { value } = e.target;

    const cep = value.replace(/\D/g, '');
    await axios
      .get(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => {
        setFieldValue('endereco_responsavel', res.data.logradouro);
        setFieldValue('bairro_responsavel', res.data.bairro);
        setFieldValue('cidade_responsavel', res.data.localidade);
        setFieldValue('uf_responsavel', res.data.uf);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const errorsHandler = (errors) => {
    if (Object.keys(errors).length !== 0) {
      const errorFields = Object.keys(errors)
        .map((name) => document.querySelector(`[name="${name}"]`))
        .filter(Boolean)
        .sort((a, b) => a.getBoundingClientRect().top + window.scrollY - (b.getBoundingClientRect().top + window.scrollY));

      if (errorFields.length > 0) {
        errorFields[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        errorFields[0].focus({ preventScroll: true });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      const firstError = Object.values(errors)[0];
      if (firstError && typeof firstError === 'string') {
        toast('error', firstError);
      }
    }
    return null;
  };

  const verifyValidations = (values) => {
    const brazilDDI = '055';
    const cellFormatted = values.celular?.replace(/[^\d]/g, '');

    if (cellFormatted.startsWith(brazilDDI)) {
      setVerifyMask(true);
    } else {
      setVerifyMask(false);
    }

    if (values.nome_social !== null && values.nome_social !== '') {
      setNomeSocialObrigatorio(true);
    } else {
      setNomeSocialObrigatorio(false);
    }

    /*  if (values.cpf?.replace(/[^\d]/g, '').length > 0) {
        setCpfObrigatorio(true);
      } else {
        setCpfObrigatorio(false);
      } */
  };

  const calcularIdade = (dataNascimento) => {
    if (!dataNascimento) return null;
    const hoje = new Date();
    const nascimento = new Date(dataNascimento);
    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mesAtual = hoje.getMonth();
    const mesNascimento = nascimento.getMonth();

    if (
      mesAtual < mesNascimento ||
      (mesAtual === mesNascimento && hoje.getDate() < nascimento.getDate())
    ) {
      idade--;
    }
    return idade;
  };

  // ✅ VALIDAÇÃO ATUALIZADA com campos do responsável novo
  const validationSchema = yup.object().shape(
    {
      // Campos do menor/adulto
      // Email e celular são opcionais para menores (responsável é o contato principal)
      email: !showIJMFormMenor
        ? yup.string().email('Endereço de email inválido').nullable().required('Preenchimento obrigatório')
        : yup.string().email('Endereço de email inválido').nullable(),
      email_confirmacao: !showIJMFormMenor
        ? yup.string().oneOf([yup.ref('email'), null], 'Os emails devem ser iguais').nullable().required('Preenchimento obrigatório')
        : yup.string().oneOf([yup.ref('email'), null], 'Os emails devem ser iguais').nullable(),
      cpf: yup
        .string()
        .test({
          message: 'CPF inválido',
          test: (value) => !value || cpf.isValid(value),
        })
        .nullable(),
      emailOrCpf:
        !isUserVerified && !isNewUser
          ? yup
              .string()
              .required('Campo obrigatório')
              .test('valid-email-or-cpf', 'Email ou CPF inválido', (value) => {
                if (!value) return false;
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
                const cpfRegex = /^\d{3}\.\d{3}\.\d{3}\-\d{2}$/;
                if (cpfRegex.test(value)) {
                  return formatCPF(value);
                }
                return emailRegex.test(value);
              })
          : yup.string().nullable(),
      nome: yup
        .string('Insira seu nome')
        .required('Preenchimento obrigatório')
        .test('full-name', 'Digite ao menos dois nomes', (value) => {
          if (!value) return false;
          return value.trim().split(/\s+/).length >= 2;
        })
        .nullable(),
      data_nascimento: yup
        .date()
        .max(new Date(), 'Não é possivel incluir uma data futura')
        .required('Preenchimento obrigatório')
        .nullable(),
      celular: showIJMFormMenor
        ? yup.string().nullable().transform((value) => value?.replace(/[^\d]/g, ''))
        : verifyMask
          ? yup
              .string()
              .required('Preenchimento obrigatório')
              .nullable()
              .transform((value) => value?.replace(/[^\d]/g, ''))
              .min(14, 'Preencha o número completo')
              .max(14, 'Preencha o número completo')
          : yup
              .string()
              .required('Preenchimento obrigatório')
              .nullable()
              .transform((value) => value?.replace(/[^\d]/g, '')),
      celular_confirmacao: showIJMFormMenor
        ? yup
            .string()
            .nullable()
            .transform((value) => value?.replace(/[^\d]/g, ''))
            .test(
              'cell-match',
              'Os números do celular devem ser iguais',
              function (value) {
                const cel = this.parent.celular?.replace(/\D/g, '');
                if (!cel || cel === '05511' || cel === '') return true;
                return this.parent.celular === value;
              }
            )
        : yup
            .string()
            .required('Preenchimento obrigatório')
            .nullable()
            .transform((value) => value?.replace(/[^\d]/g, ''))
            .test(
              'cell-match',
              'Os números do celular devem ser iguais',
              function (value) {
                return this.parent.celular === value;
              }
            ),
      // Senha obrigatória apenas para novo usuário adulto Mocidade
      senha: isNewUser && !showIJMFormMenor
        ? yup.string().required('Preenchimento obrigatório')
        : yup.string().nullable(),
      senhaConfirmacao: isNewUser && !showIJMFormMenor
        ? yup
            .string()
            .required('Preenchimento obrigatório')
            .oneOf([yup.ref('senha')], 'As senhas devem ser iguais')
        : yup.string().nullable(),
      grau_parentesco:
        showIJMFormMenor && precisaResponsavel
          ? yup.string().required('Selecione o grau de parentesco')
          : yup.string().nullable(),
      contato_emergencia_1_nome: showIJMFormMenor
        ? yup
            .string()
            .required('Pelo menos um contato de emergência é obrigatório')
        : yup.string().nullable(),
      contato_emergencia_1_celular: showIJMFormMenor
        ? yup
            .string()
            .required('Celular do contato de emergência é obrigatório')
        : yup.string().nullable(),
      rg_menor: yup.string().nullable(),

      // Campos do responsável (quando for novo — sem $context, usa closure diretamente)
      nome_responsavel: precisaResponsavel && !responsavelEncontrado
        ? yup.string().required('Nome do responsável é obrigatório')
        : yup.string().nullable(),
      cpf_responsavel: precisaResponsavel && !responsavelEncontrado
        ? yup.string().required('CPF do responsável é obrigatório').test({
            message: 'CPF inválido',
            test: (value) => cpf.isValid(value),
          })
        : yup.string().nullable(),
      email_responsavel: precisaResponsavel && !responsavelEncontrado
        ? yup.string().email('Email do responsável inválido').required('Email do responsável é obrigatório')
        : yup.string().email('Email do responsável inválido').nullable(),
      email_responsavel_confirmacao: precisaResponsavel && !responsavelEncontrado
        ? yup.string().oneOf([yup.ref('email_responsavel'), null], 'Os emails do responsável devem ser iguais').required('Confirmação do email é obrigatória')
        : yup.string().oneOf([yup.ref('email_responsavel'), null], 'Os emails do responsável devem ser iguais').nullable(),
      data_nascimento_responsavel: precisaResponsavel && !responsavelEncontrado
        ? yup
            .date()
            .required('Data de nascimento do responsável é obrigatória')
            .max(new Date(), 'Não é possível incluir uma data futura')
            .test('adulto', 'Responsável deve ser maior de 18 anos', function (value) {
              if (!value) return false;
              return calcularIdade(value) >= 18;
            })
        : yup.date().nullable(),
      senha_responsavel: precisaResponsavel && !responsavelEncontrado
        ? yup.string().required('Senha do responsável é obrigatória')
        : yup.string().nullable(),
      senha_responsavel_confirmacao: precisaResponsavel && !responsavelEncontrado
        ? yup.string().oneOf([yup.ref('senha_responsavel'), null], 'As senhas do responsável devem ser iguais').required('Confirmação da senha é obrigatória')
        : yup.string().nullable(),
      CEP_responsavel: precisaResponsavel && !responsavelEncontrado
        ? yup.string().required('CEP do responsável é obrigatório')
        : yup.string().nullable(),
      endereco_responsavel: precisaResponsavel && !responsavelEncontrado
        ? yup.string().required('Endereço do responsável é obrigatório')
        : yup.string().nullable(),
      numero_responsavel: precisaResponsavel && !responsavelEncontrado
        ? yup.string().required('Número do endereço é obrigatório')
        : yup.string().nullable(),
      bairro_responsavel: precisaResponsavel && !responsavelEncontrado
        ? yup.string().required('Bairro do responsável é obrigatório')
        : yup.string().nullable(),
      cidade_responsavel: precisaResponsavel && !responsavelEncontrado
        ? yup.string().required('Cidade do responsável é obrigatória')
        : yup.string().nullable(),
      uf_responsavel: precisaResponsavel && !responsavelEncontrado
        ? yup.string().required('UF do responsável é obrigatória')
        : yup.string().nullable(),
      celular_responsavel: precisaResponsavel && !responsavelEncontrado
        ? verifyMask
          ? yup
              .string()
              .required('Celular do responsável é obrigatório')
              .nullable()
              .transform((value) => value?.replace(/[^\d]/g, ''))
              .min(14, 'Preencha o número completo')
              .max(14, 'Preencha o número completo')
          : yup
              .string()
              .required('Celular do responsável é obrigatório')
              .nullable()
              .transform((value) => value?.replace(/[^\d]/g, ''))
        : yup.string().nullable(),
      celular_responsavel_confirmacao: precisaResponsavel && !responsavelEncontrado
        ? yup
            .string()
            .required('Confirmação do celular é obrigatória')
            .test('cell-match-resp', 'Os celulares do responsável devem ser iguais', function (value) {
              const cel = (this.parent.celular_responsavel || '').replace(/[^\d]/g, '');
              const conf = (value || '').replace(/[^\d]/g, '');
              return cel === conf;
            })
        : yup.string().nullable(),
    },
    [
      ['email', 'cpf'],
      ['email', 'rg'],
      ['cpf', 'rg'],
    ]
  );

  // Yup próprio da etapa 'cadastroResponsavel' (item 7.2) — cadastro do
  // responsável novo separado do formulário do menor, sempre obrigatório
  // (não depende de precisaResponsavel/showIJMFormMenor como o schema acima).
  const validationSchemaCadastroResponsavel = yup.object().shape({
    nome: yup
      .string()
      .required('Preenchimento obrigatório')
      .test('full-name', 'Digite ao menos dois nomes', (value) => {
        if (!value) return false;
        return value.trim().split(/\s+/).length >= 2;
      }),
    data_nascimento: yup
      .date()
      .required('Preenchimento obrigatório')
      .max(new Date(), 'Não é possível incluir uma data futura')
      .test('adulto', 'Responsável deve ser maior de 18 anos', function (value) {
        if (!value) return false;
        return calcularIdade(value) >= 18;
      }),
    cpf: yup
      .string()
      .required('Preenchimento obrigatório')
      .test({ message: 'CPF inválido', test: (value) => !value || cpf.isValid(value) }),
    email: yup.string().email('Endereço de email inválido').required('Preenchimento obrigatório'),
    email_confirmacao: yup
      .string()
      .oneOf([yup.ref('email'), null], 'Os emails devem ser iguais')
      .required('Preenchimento obrigatório'),
    celular: yup
      .string()
      .required('Preenchimento obrigatório')
      .transform((value) => value?.replace(/[^\d]/g, ''))
      .min(14, 'Preencha o número completo')
      .max(14, 'Preencha o número completo'),
    celular_confirmacao: yup
      .string()
      .required('Preenchimento obrigatório')
      .transform((value) => value?.replace(/[^\d]/g, ''))
      .test('cell-match', 'Os números do celular devem ser iguais', function (value) {
        return this.parent.celular === value;
      }),
    CEP: yup.string().when('pais', { is: 'BR', then: (schema) => schema.required('Preenchimento obrigatório') }),
    endereco: yup.string().required('Preenchimento obrigatório'),
    numero: yup.string().when('pais', { is: 'BR', then: (schema) => schema.required('Preenchimento obrigatório') }),
    bairro: yup.string().when('pais', { is: 'BR', then: (schema) => schema.required('Preenchimento obrigatório') }),
    cidade: yup.string().required('Preenchimento obrigatório'),
    uf: yup.string().when('pais', { is: 'BR', then: (schema) => schema.required('Preenchimento obrigatório') }),
    senha: yup.string().required('Preenchimento obrigatório'),
    senhaConfirmacao: yup
      .string()
      .required('Preenchimento obrigatório')
      .oneOf([yup.ref('senha')], 'As senhas devem ser iguais'),
  });

  const toast = (variant, message, timer = 15000, type = false) => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: timer,
      onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: variant,
      title: message,
      showCloseButton: true,
      closeButtonAriaLabel: 'Fechar',
    });
  };

  const getCourseIntro = useCallback(async () => {
    try {
      await ApiService.get(`/cursos-introdutorios/${id}`, {
        params: { isOpen: true },
      })
        .then((response) => {
          setClasses(response.data.Turma);
          setTexts(response.data);
          setIsEnrollmentBlocked(
            response.data?.matricula_automatica_bloqueada || false
          );
        })
        .catch((error) => {
          if (error.response && error.response.status === 403) {
            setCourseIsClosed(true);
          }
        });
    } catch (err) {
    }
  }, []);

  useEffect(() => {
    if (id) getCourseIntro();
  }, []);

  const handleDataNascimentoBlur = (e, setFieldValue) => {
    const dataNascimento = e.target.value;

    if (!dataNascimento || dataNascimento.length < 10) {
      return;
    }

    const idadeCalculada = calcularIdade(dataNascimento);

    // Popups de idade apenas nas etapas de login/escolhaCadastro (não no formulário final)
    if (!showIJMFormMenor && etapaAtual !== 'formulario') {
      if (idadeCalculada < 18) {
        setShowPopupMenorIdade(true);
      } else if (idadeCalculada >= 18 && idadeCalculada <= 24) {
        setShowPopupEscolha(true);
      } else if (idadeCalculada >= 25) {
        setShowPopupAdulto(true);
      }
    }
  };

  const verificarMenoresVinculados = async (pessoaId) => {
    try {
      const responseVerifica = await ApiService.get(
        `/menores/verificar/${pessoaId}`
      );

      if (responseVerifica.data.temMenores) {
        const responseLista = await ApiService.get(
          `/menores/responsavel/${pessoaId}`
        );
        setMenoresVinculados(responseLista.data);
        setIsResponsavel(true);
        return true;
      }

      return false;
    } catch (error) {
      console.error('Erro ao verificar menores:', error);
      return false;
    }
  };

  // 🔹 FLUXO 2: USUÁRIO EXISTENTE (LOGIN)
  const onSignIn = async (emailOrCpf, senha) => {
    setIsLoadingLogin(true);
    try {
      let payload = { senha, id, turmaId };

      if (/\S+@\S+\.\S+/.test(emailOrCpf)) {
        payload.email = emailOrCpf;
      } else {
        payload.cpf = emailOrCpf;
      }

      await authServices.verifySenha(payload).then((data) => {
        const { senha: _, ...userWithoutPassword } = data?.user;

        setUser(userWithoutPassword);
        setUsuarioLogado(userWithoutPassword);
        setUserHasPassword(true);
        setIsUserVerified(true);

        setEtapaAtual('confirmarAdulto');
        setConfirmedUserData(false);

        const idadeUsuario = calcularIdade(userWithoutPassword.data_nascimento);
        setIdade(idadeUsuario);

        verificarMenoresVinculados(userWithoutPassword.pessoa_id);
      });
    } catch (err) {
      console.error('❌ Erro no login:', err);
      toast('error', err.response?.data?.error || 'Erro ao fazer login');
    } finally {
      setIsLoadingLogin(false);
    }
  };

  // ✅ FUNÇÃO: Confirmar dados do adulto
  const confirmarDadosAdulto = async (values, setFieldError) => {
    try {
      if (!values.email || !values.celular) {
        toast('error', 'Por favor, preencha todos os campos obrigatórios');
        return;
      }

      const dadosAtualizados = {
        nome: values.nome,
        data_nascimento: values.data_nascimento,
        cpf: values.cpf,
        rg: values.rg,
        email: values.email,
        celular: values.celular,
        celular_confirmacao: values.celular_confirmacao,
        email_confirmacao: values.email_confirmacao,
        telefone: values.telefone,
        pais: values.pais,
        CEP: values.CEP,
        endereco: values.endereco,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        uf: values.uf,
        pessoa_id: usuarioLogado.pessoa_id,
      };

      await ApiService.put(`/pessoa/${usuarioLogado.pessoa_id}`, {
        values: dadosAtualizados,
      });

      const usuarioAtualizado = { ...usuarioLogado, ...dadosAtualizados };
      setUser(usuarioAtualizado);
      setUsuarioLogado(usuarioAtualizado);

      setConfirmedUserData(true);
      setEtapaAtual('escolha');

      const idadeUsuario = calcularIdade(values.data_nascimento);
      // Mantém o estado `idade` sincronizado com a data confirmada aqui (pode
      // ter sido editada pelo usuário) — usado pelo DialogOpcoesEscolha para
      // decidir se mostra a opção "Matrícula na Mocidade".
      setIdade(idadeUsuario);

      if (idadeUsuario < 18) {
        toast(
          'warning',
          'Usuários menores de 18 anos não podem se matricular de forma independente. Por favor, peça ao seu responsável para fazer o cadastro.',
          8000
        );
        setEtapaAtual('login');
        setIsUserVerified(false);
        setUsuarioLogado(null);
        setUser(initialValues);
        return;
      } else if (isResponsavel && menoresVinculados.length > 0) {
        setShowDialogSelecionarMenor(true);
      } else {
        setShowDialogOpcoes(true);
      }

      toast('success', 'Dados atualizados com sucesso!');
    } catch (error) {
      toast('error', error.response?.data?.error || error.message || 'Erro ao atualizar dados');
    }
  };

  // Abre o formulário de menor novo já vinculado a um responsável.
  // Usada pelo botão "Cadastrar e matricular novo menor" (DialogOpcoesEscolha),
  // pelo fluxo pós-matrícula (oferecerMatriculaOutroMenor) e pelo cadastro de responsável novo
  // (handleSubmitCadastroResponsavel). Recebe o responsável por parâmetro (em vez de ler
  // `usuarioLogado` direto) porque logo após criar um responsável novo o estado ainda não
  // teria sido atualizado no momento da chamada (closure desatualizada).
  const cadastrarNovoMenor = (responsavel = usuarioLogado) => {
    setMenorSelecionado(null);
    setUser(initialValues);
    setResponsavelEncontrado(responsavel);
    setIsUserVerified(true);
    setShowIJMForm(true);
    setShowIJMFormMenor(true);
    setPrecisaResponsavel(true);
    setEscolhaCadastro('menor');
    setEtapaAtual('formulario');

    setTimeout(() => {
      if (formikRef.current) {
        formikRef.current.setValues({
          ...initialValuesIJM,
          // Email e celular do menor ficam em branco — responsável é o contato principal
          email: '',
          email_confirmacao: '',
          celular: '05511',
          celular_confirmacao: '',
          telefone: '05511',
          // Endereço só é copiado se o usuário marcar "Usar endereço do responsável" no formulário
          pais: responsavel.pais || 'BR',
        });
      }
    }, 100);
  };

  // ✅ FUNÇÃO: handleSubmitCadastroResponsavel (item 7.2 — etapa 'cadastroResponsavel')
  // Cadastra só a pessoa responsável (sem menor, sem turma) via /cadastro-inicial.
  const handleSubmitCadastroResponsavel = async (values, setFieldError, setSubmitting) => {
    try {
      const dadosPessoa = {
        nome: values.nome,
        nome_social: values.nome_social || null,
        data_nascimento: values.data_nascimento,
        genero: values.genero || null,
        cpf: values.cpf,
        rg: values.rg || null,
        email: values.email,
        celular: values.celular,
        telefone: values.telefone || '05511',
        pais: values.pais,
        CEP: values.CEP,
        endereco: values.endereco,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        uf: values.uf,
        senha: values.senha,
      };

      const response = await ApiService.post('/cadastro-inicial', {
        values: dadosPessoa,
      });
      const pessoaCriada = response.data;

      setUsuarioLogado(pessoaCriada);

      const resultado = await Swal.fire({
        title: 'Cadastro realizado com sucesso!',
        text: 'Deseja seguir para matricular um menor agora?',
        icon: 'success',
        showCancelButton: true,
        confirmButtonText: 'Sim, matricular menor',
        cancelButtonText: 'Não, encerrar',
      });

      if (resultado.isConfirmed) {
        cadastrarNovoMenor(pessoaCriada);
      } else {
        navigate('/lista-de-cursos-mocidade');
      }
    } catch (error) {
      Swal.fire({
        title: 'Aviso',
        text: error.response?.data?.error || 'Erro ao realizar cadastro',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
    } finally {
      setSubmitting(false);
    }
  };

  // OpcoesHerancaDados extraído para src/app/components/IJM/cards/

  // CardEnderecoResponsavel extraído para src/app/components/IJM/cards/

  // FormularioResponsavelNovo extraído para src/app/components/IJM/forms/

  // Dialogs/Popups extraídos para src/app/components/IJM/dialogs/

  const getFileUrl = (nome) => `${process.env.REACT_APP_API_KEY}/images/${nome}`;
  const isImage = (nome) => /\.(jpg|jpeg|png)$/i.test(nome);

  const renderDocumentoTutela = () => {
    const mostrarExistente = documentoExistente && !documentoRemovido && !documentoTutela;
    const mostrarNovo = !!documentoTutela;

    return (
      <Box ref={uploadTutelaRef}>
        {mostrarExistente && (
          <Box display='flex' alignItems='center' gap={1} sx={{ mb: 1 }}>
            {isImage(documentoExistente.nome) ? (
              <Box
                component='a'
                href={getFileUrl(documentoExistente.nome)}
                target='_blank'
                rel='noopener noreferrer'
              >
                <Box
                  component='img'
                  src={getFileUrl(documentoExistente.nome)}
                  alt={documentoExistente.nome_label}
                  sx={{ height: 60, borderRadius: 1, border: '1px solid #ddd', cursor: 'pointer' }}
                />
              </Box>
            ) : (
              <Typography
                variant='body2'
                component='a'
                href={getFileUrl(documentoExistente.nome)}
                target='_blank'
                rel='noopener noreferrer'
                sx={{ color: 'primary.main' }}
              >
                {documentoExistente.nome_label}
              </Typography>
            )}
            <Button
              size='small'
              color='error'
              onClick={() => setDocumentoRemovido(true)}
            >
              Remover
            </Button>
          </Box>
        )}

        {mostrarNovo && (
          <Box display='flex' alignItems='center' gap={1} sx={{ mb: 1 }}>
            {isImage(documentoTutela.name) ? (
              <Box
                component='a'
                href={URL.createObjectURL(documentoTutela)}
                target='_blank'
                rel='noopener noreferrer'
              >
                <Box
                  component='img'
                  src={URL.createObjectURL(documentoTutela)}
                  alt={documentoTutela.name}
                  sx={{ height: 60, borderRadius: 1, border: '1px solid #ddd', cursor: 'pointer' }}
                />
              </Box>
            ) : (
              <Typography variant='body2' color='text.secondary'>
                {documentoTutela.name}
              </Typography>
            )}
            <Button size='small' color='error' onClick={() => setDocumentoTutela(null)}>
              Remover
            </Button>
          </Box>
        )}

        {!mostrarExistente && !mostrarNovo && (
          <Button variant='outlined' size='small' component='label'>
            Selecionar arquivo
            <input
              type='file'
              accept='.pdf,.jpg,.jpeg,.png'
              hidden
              onChange={(e) => {
                setDocumentoTutela(e.target.files[0] || null);
                setDocumentoRemovido(false);
              }}
            />
          </Button>
        )}
      </Box>
    );
  };

  // ✅ FUNÇÃO: handleSubmitIJM atualizada para responsável novo
  const handleSubmitIJM = async (values, setFieldError, setSubmitting) => {
    try {
      if (!values.turmas_id) {
        return toast('warning', 'Por favor, selecione um horário');
      }

      // Validar documento de tutela para Representante Legal
      if (values.grau_parentesco === 'representante_legal') {
        const tutelaAusente = !documentoTutela && (!documentoExistente || documentoRemovido);
        if (tutelaAusente) {
          toast('error', 'O documento de guarda/tutela é obrigatório para Representante Legal');
          uploadTutelaRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setSubmitting(false);
          return;
        }
      }

      const uploadDocumentoTutela = async (menorId) => {
        if (!documentoTutela || values.grau_parentesco !== 'representante_legal') return;
        const formDataUpload = new FormData();
        formDataUpload.append('docs', documentoTutela);
        formDataUpload.append('menor_id', menorId);
        formDataUpload.append('tipo_0', 'tutela');
        formDataUpload.append('nome_label_0', documentoTutela.name);
        await ApiService.post('/menores/documentos/upload', formDataUpload, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      };

      // ✅ PREPARAR DADOS DO RESPONSÁVEL (se for novo)
      let dadosResponsavel = null;
      if (precisaResponsavel && !responsavelEncontrado) {
        // Validar dados mínimos do responsável
        if (
          !values.nome_responsavel ||
          !values.cpf_responsavel ||
          !values.email_responsavel ||
          !values.endereco_responsavel ||
          !values.CEP_responsavel
        ) {
          toast(
            'error',
            'Por favor, preencha todos os dados obrigatórios do responsável'
          );
          return;
        }

        // Validar idade do responsável
        const idadeResponsavel = calcularIdade(
          values.data_nascimento_responsavel
        );
        if (idadeResponsavel < 18) {
          toast('error', 'O responsável deve ter 18 anos ou mais');
          return;
        }

        dadosResponsavel = {
          nome: values.nome_responsavel,
          data_nascimento: values.data_nascimento_responsavel,
          cpf: values.cpf_responsavel,
          rg: values.rg_responsavel || null,
          email: values.email_responsavel,
          email_confirmacao: values.email_responsavel_confirmacao,
          celular: values.celular_responsavel || '05511',
          telefone: values.telefone_responsavel || '05511',
          senha: values.senha_responsavel,
          // ✅ CORRIGIDO: Endereço do responsável
          pais: values.pais_responsavel || 'BR',
          CEP: values.CEP_responsavel || null,
          endereco: values.endereco_responsavel,
          numero: values.numero_responsavel,
          complemento: values.complemento_responsavel || null,
          bairro: values.bairro_responsavel,
          cidade: values.cidade_responsavel,
          uf: values.uf_responsavel || null,
          estado: values.estado_responsavel || null,
          codigo_postal: values.codigo_postal_responsavel || null,
        };

      }

      // ✅ PREPARAR DADOS DO MENOR
      // Celular/telefone padrão vazio ('05511') é tratado como null
      const celularMenor = values.celular?.replace(/\D/g, '');
      const telefoneMenor = values.telefone?.replace(/\D/g, '');
      // Celular do responsável (existente ou novo) como fallback
      const celularFonteResponsavel = responsavelEncontrado?.celular || values.celular_responsavel || null;
      const dadosPessoa = {
        nome: values.nome,
        data_nascimento: values.data_nascimento,
        cpf: values.cpf,
        rg: values.rg_menor || values.rg,
        /* celular: mesmoCelular
          ? celularFonteResponsavel
          : (celularMenor && celularMenor !== '05511' ? values.celular : celularFonteResponsavel), */
        celular: mesmoCelular ? '05511' : (values.celular || '05511'),
        //telefone: telefoneMenor && telefoneMenor !== '05511' ? values.telefone : null,
        telefone: values.telefone || '05511',
        /*  email: responsavelEncontrado ? null : values.email, // Email fica null se tiver responsável
        endereco:
          mesmoEndereco && responsavelEncontrado
            ? responsavelEncontrado.endereco
            : values.endereco,
        numero:
          mesmoEndereco && responsavelEncontrado
            ? responsavelEncontrado.numero
            : values.numero,
        complemento:
          mesmoEndereco && responsavelEncontrado
            ? responsavelEncontrado.complemento
            : values.complemento,
        bairro:
          mesmoEndereco && responsavelEncontrado
            ? responsavelEncontrado.bairro
            : values.bairro,
        cidade:
          mesmoEndereco && responsavelEncontrado
            ? responsavelEncontrado.cidade
            : values.cidade,
        uf:
          mesmoEndereco && responsavelEncontrado
            ? responsavelEncontrado.uf
            : values.uf,
        CEP:
          mesmoEndereco && responsavelEncontrado
            ? responsavelEncontrado.CEP
            : values.CEP,
        pais:
          mesmoEndereco && responsavelEncontrado
            ? responsavelEncontrado.pais
            : values.pais, */
        email: mesmoEmail ? null : (values.email || null), // null quando menor usa email do responsável
        endereco: values.endereco,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        uf: values.uf,
        CEP: values.CEP,
        pais: values.pais,
        senha: values.senha,
      };

      // ✅ PREPARAR DADOS ESPECÍFICOS DO MENOR
      const dadosMenor = {
        grau_parentesco: precisaResponsavel ? values.grau_parentesco : null,
        documento_tutela: null,
        deficiencias:
          values.deficiencias?.length > 0
            ? {
                tipos: values.deficiencias,
                outra: values.outra_deficiencia,
              }
            : null,
        alergias:
          values.alergias?.length > 0
            ? {
                tipos: values.alergias,
                outra: values.outra_alergia,
              }
            : null,
        problemas_saude:
          values.problemas_saude?.length > 0
            ? {
                tipos: values.problemas_saude,
                outro: values.outro_problema_saude,
              }
            : null,
        transtornos:
          values.transtornos?.length > 0
            ? {
                tipos: values.transtornos,
                outro: values.outro_transtorno,
              }
            : null,
        medicacao_continua: values.medicacao_continua,
        medicamentos: values.medicamentos,
        pode_ir_sozinho: values.pode_ir_sozinho,
        foto_crianca: null,
        responsavel_id: responsavelEncontrado?.pessoa_id,
      };

      // ✅ PREPARAR CONTATOS DE EMERGÊNCIA
      const contatosEmergencia = [
        {
          nome: values.contato_emergencia_1_nome,
          parentesco: values.contato_emergencia_1_parentesco,
          celular: values.contato_emergencia_1_celular,
        },
        {
          nome: values.contato_emergencia_2_nome,
          parentesco: values.contato_emergencia_2_parentesco,
          celular: values.contato_emergencia_2_celular,
        },
        {
          nome: values.contato_emergencia_3_nome,
          parentesco: values.contato_emergencia_3_parentesco,
          celular: values.contato_emergencia_3_celular,
        },
      ].filter((c) => c.nome && c.celular);

      // ✅ PREPARAR PESSOAS AUTORIZADAS
      const pessoasAutorizadas = [
        {
          nome: values.autorizado_1_nome,
          parentesco: values.autorizado_1_parentesco,
          celular: values.autorizado_1_celular,
        },
        {
          nome: values.autorizado_2_nome,
          parentesco: values.autorizado_2_parentesco,
          celular: values.autorizado_2_celular,
        },
        {
          nome: values.autorizado_3_nome,
          parentesco: values.autorizado_3_parentesco,
          celular: values.autorizado_3_celular,
        },
      ].filter((p) => p.nome && p.celular);

      // ✅ CONSTRUIR PAYLOAD
      const payload = {
        dadosPessoa,
        dadosResponsavel,
        dadosMenor,
        contatosEmergencia,
        pessoasAutorizadas,
        turmas_id: values.turmas_id,
        flags_heranca: {
          mesmo_endereco: mesmoEndereco,
          mesmo_celular: mesmoCelular,
          mesmo_telefone: mesmoTelefone,
        },
      };

      // Função auxiliar: após sucesso ou "já matriculado", segue o fluxo com os demais menores
      const oferecerMatriculaOutroMenor = async (idProcessado) => {
        if (idProcessado) {
          menoresJaMatriculadosRef.current.push(idProcessado);
        }
        const outrosMenores = menoresVinculados.filter(
          (m) => !menoresJaMatriculadosRef.current.includes(m.menor_id)
        );
        if (outrosMenores.length > 0) {
          // Ainda há menor(es) vinculado(s) pendente(s) — volta direto pra seleção, sem perguntar
          setMenorSelecionado(null);
          formikRef.current?.resetForm({ values: initialValuesIJM });
          setShowDialogSelecionarMenor(true);
          setEtapaAtual('escolha');
          return;
        }
        // Nenhum menor vinculado pendente — pergunta se quer cadastrar um novo
        const resultado = await Swal.fire({
          title: 'Deseja cadastrar outro menor?',
          text: 'Você pode cadastrar e matricular um novo menor agora.',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim, cadastrar novo menor',
          cancelButtonText: 'Não, encerrar',
        });
        if (resultado.isConfirmed) {
          cadastrarNovoMenor();
        } else {
          navigate('/lista-de-cursos-mocidade');
        }
      };

      let response;
      let menorIdProcessado = menorSelecionado?.menor_id || null;
      if (menorSelecionado && menorSelecionado.menor_id) {
        // CASO 1: Menor existente — salvar dados primeiro (E4: independente da matrícula)
        await ApiService.put(
          `/menores/${menorSelecionado.menor_id}/atualizar`,
          {
            dadosPessoa,
            dadosMenor,
            contatosEmergencia,
            pessoasAutorizadas,
          }
        );

        // Upload documento tutela (remove antigo se necessário)
        if (documentoRemovido && documentoExistente) {
          await ApiService.delete(`/menores/documentos/${documentoExistente.documento_menor_id}`);
        }
        await uploadDocumentoTutela(menorSelecionado.menor_id);

        // Depois tentar matrícula (pode falhar se já matriculado)
        try {
          const matriculaResponse = await ApiService.post(
            `/menores/${menorSelecionado.menor_id}/matricular`,
            { turmas_id: values.turmas_id }
          );
          response = { data: { matricula: matriculaResponse.data } };
        } catch (matriculaError) {
          // E2 + E4: dados já foram salvos; mostrar aviso amigável (sem "Erro"/X)
          const msgBackend = matriculaError.response?.data?.error || '';
          const jaMatriculado = msgBackend
            .toLowerCase()
            .includes('já está matriculado');

          await Swal.fire({
            title: jaMatriculado
              ? 'Menor já matriculado nesta turma'
              : 'Não foi possível concluir a matrícula',
            text: jaMatriculado
              ? 'Este menor já está matriculado nesta turma, então não é necessário matriculá-lo novamente. As alterações feitas nos dados do menor foram salvas com sucesso.'
              : `As alterações feitas nos dados do menor foram salvas com sucesso, mas não foi possível concluir a matrícula no momento.${
                  msgBackend ? ` (${msgBackend})` : ''
                }`,
            icon: 'info',
            confirmButtonText: 'OK',
          });
          await oferecerMatriculaOutroMenor(menorIdProcessado);
          return;
        }
      } else {
        // CASO 2: Novo menor (com ou sem responsável novo)
        response = await ApiService.post('/menores', payload);
        const menorId = response.data?.data?.menor?.menor_id;
        const menorPessoaId = response.data?.data?.menor?.pessoa_id;
        menorIdProcessado = menorId || null;
        if (menorId) await uploadDocumentoTutela(menorId);

        // Mantém menoresVinculados em dia: sem isso, um menor cadastrado
        // nesta sessão nunca aparece na tela "Selecione o menor" depois.
        if (menorId && menorPessoaId) {
          setMenoresVinculados((prev) => [
            ...prev,
            {
              menor_id: menorId,
              pessoa_id: menorPessoaId,
              pessoa: {
                nome: dadosPessoa.nome,
                cpf: dadosPessoa.cpf,
                data_nascimento: dadosPessoa.data_nascimento,
              },
            },
          ]);
        }
      }

      await Swal.fire({
        title: menorSelecionado
          ? 'Dados atualizados e matrícula realizada!'
          : 'Cadastro realizado com sucesso!',
        text: dadosResponsavel
          ? 'Você e o menor foram cadastrados com sucesso.'
          : 'A matrícula foi registrada na área de Infância, Juventude e Mocidade.',
        icon: 'success',
        confirmButtonText: 'OK',
      });
      await oferecerMatriculaOutroMenor(menorIdProcessado);
    } catch (error) {
      console.error('❌ Erro ao cadastrar/atualizar:', error);
      Swal.fire({
        title: 'Aviso',
        text: error.response?.data?.error || 'Erro ao realizar operação',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
    } finally {
      setSubmitting(false);
    }
  };

  // ✅ FUNÇÃO: handleSubmitNormal (para adulto se matriculando)
  const handleSubmitNormal = async (values, setFieldError, setSubmitting) => {
    try {
      if (!values.turmas_id) {
        return toast('warning', 'Por favor, selecione um horário');
      }

      const payload = {
        dadosPessoa: {
          pessoa_id: usuarioLogado?.pessoa_id || null,
          nome: values.nome,
          data_nascimento: values.data_nascimento,
          cpf: values.cpf,
          rg: values.rg,
          email: values.email,
          celular: values.celular,
          telefone: values.telefone,
          pais: values.pais,
          CEP: values.CEP,
          endereco: values.endereco,
          numero: values.numero,
          complemento: values.complemento,
          bairro: values.bairro,
          cidade: values.cidade,
          uf: values.uf,
          senha: !usuarioLogado?.pessoa_id ? values.senha : null,
        },
        turmas_id: values.turmas_id,
      };

      await ApiService.post('/menores/matricula-normal', payload);

      Swal.fire({
        title: 'Matrícula realizada com sucesso!',
        icon: 'success',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/lista-de-cursos-mocidade');
      });
    } catch (error) {
      console.error('❌ Erro ao realizar matrícula:', error);
      Swal.fire(
        'Erro',
        error.response?.data?.error || 'Erro ao realizar matrícula',
        'error'
      );
    } finally {
      setSubmitting(false);
    }
  };

  // ✅ FUNÇÃO: handleSubmit principal
  const handleSubmit = async (
    values,
    { setSubmitting, setFieldError, setStatus }
  ) => {
    if (isEnrollmentBlocked) {
      return toast('error', 'As matrículas para este curso estão bloqueadas no momento.');
    }

    if (!values.turmas_id) {
      toast('warning', 'Por favor, selecione um horário');
      const turmaField = document.querySelector('[name="turmas_id"]');
      if (turmaField) turmaField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (showIJMFormMenor) {
      await handleSubmitIJM(values, setFieldError, setSubmitting);
    } else {
      await handleSubmitNormal(values, setFieldError, setSubmitting);
    }
  };

  // CheckboxSection e ContatoCard extraídos para src/app/components/IJM/shared/

  const opcoesDeficiencias = [
    'Auditiva',
    'Física',
    'Visual',
    'Intelectual',
    'Outra',
  ];
  const opcoesAlergias = [
    'Alimento',
    'Medicamento',
    'Odores',
    'Poeira',
    'Pelo de animais',
    'Outra',
  ];
  const opcoesProblemasSaude = [
    'Diabetes',
    'Asma',
    'Epilepsia',
    'Hipertensão',
    'Bronquite',
    'Outra',
  ];
  const opcoesTranstornos = [
    'TEA',
    'TDAH',
    'TAG',
    'Transtorno de aprendizagem',
    'Outro',
  ];

  const getEtapaInfo = () => {
    if (isNewUser) {
      if (escolhaCadastro === 'responsavelMenor') {
        // Fluxo: escolhaCadastro → cadastroResponsavel → formulario (3 etapas)
        const map = {
          escolhaCadastro:     { label: 'Etapa 1 de 3 — Tipo de cadastro',          value: 33  },
          cadastroResponsavel: { label: 'Etapa 2 de 3 — Cadastro do responsável',   value: 66  },
          formulario:          { label: 'Etapa 3 de 3 — Dados do menor',            value: 100 },
        };
        return map[etapaAtual] || null;
      }
      // Fluxo: escolhaCadastro → formulario (2 etapas)
      const map = {
        escolhaCadastro: { label: 'Etapa 1 de 2 — Tipo de cadastro', value: 50  },
        formulario:      { label: 'Etapa 2 de 2 — Formulário',        value: 100 },
      };
      return map[etapaAtual] || null;
    }
    if (isResponsavel) {
      // Fluxo: login → confirmarAdulto → escolha → formulario (4 etapas)
      const map = {
        confirmarAdulto: { label: 'Etapa 2 de 4 — Confirme seus dados',   value: 50  },
        escolha:         { label: 'Etapa 3 de 4 — Escolha de matrícula',   value: 75  },
        formulario:      { label: 'Etapa 4 de 4 — Formulário',             value: 100 },
      };
      return map[etapaAtual] || null;
    }
    // Fluxo: login → confirmarAdulto → formulario (3 etapas)
    const map = {
      confirmarAdulto: { label: 'Etapa 2 de 3 — Confirme seus dados', value: 67  },
      formulario:      { label: 'Etapa 3 de 3 — Formulário',           value: 100 },
    };
    return map[etapaAtual] || null;
  };

  return (
    <JumboContentLayout layoutOptions={layoutOptions}>
      {courseIsClosed ? (
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
          height={'100vh'}
        >
          <Typography variant='h1' fontSize={'2.5rem'}>
            As inscrições para este curso não estão disponíveis.
          </Typography>
        </Box>
      ) : (
        <>
          {/* Popups e Dialogs */}
          <PopupEscolhaCadastro
            showPopupEscolha={showPopupEscolha}
            setShowPopupEscolha={setShowPopupEscolha}
            escolhaCadastro={escolhaCadastro}
            setEscolhaCadastro={setEscolhaCadastro}
            setPrecisaResponsavel={setPrecisaResponsavel}
            setShowIJMForm={setShowIJMForm}
          />
          <PopupAdulto
            showPopupAdulto={showPopupAdulto}
            setShowPopupAdulto={setShowPopupAdulto}
            escolhaCadastro={escolhaCadastro}
            setEscolhaCadastro={setEscolhaCadastro}
            setPrecisaResponsavel={setPrecisaResponsavel}
            setShowIJMForm={setShowIJMForm}
            setShowIJMFormMenor={setShowIJMFormMenor}
            setIsNewUser={setIsNewUser}
            setUser={setUser}
            initialValues={initialValues}
            setIdade={setIdade}
            setResponsavelEncontrado={setResponsavelEncontrado}
            setMenorSelecionado={setMenorSelecionado}
            setIsUserVerified={setIsUserVerified}
            setIsResponsavel={setIsResponsavel}
            setMenoresVinculados={setMenoresVinculados}
            setUserHasPassword={setUserHasPassword}
            setEnderecoConfirmado={setEnderecoConfirmado}
            setEtapaAtual={setEtapaAtual}
          />
          <PopupMenorIdade
            showPopupMenorIdade={showPopupMenorIdade}
            setShowPopupMenorIdade={setShowPopupMenorIdade}
            setIsNewUser={setIsNewUser}
            setUser={setUser}
            initialValues={initialValues}
          />
          <DialogOpcoesEscolha
            showDialogOpcoes={showDialogOpcoes}
            setShowDialogOpcoes={setShowDialogOpcoes}
            isResponsavel={isResponsavel}
            idade={idade}
            usuarioLogado={usuarioLogado}
            initialValues={initialValues}
            formikRef={formikRef}
            setUser={setUser}
            setUserHasPassword={setUserHasPassword}
            setIsUserVerified={setIsUserVerified}
            setShowIJMForm={setShowIJMForm}
            setShowIJMFormMenor={setShowIJMFormMenor}
            setPrecisaResponsavel={setPrecisaResponsavel}
            setEscolhaCadastro={setEscolhaCadastro}
            setEtapaAtual={setEtapaAtual}
            setShowDialogSelecionarMenor={setShowDialogSelecionarMenor}
            cadastrarNovoMenor={cadastrarNovoMenor}
          />
          <DialogSelecionarMenor
            showDialogSelecionarMenor={showDialogSelecionarMenor}
            setShowDialogSelecionarMenor={setShowDialogSelecionarMenor}
            menoresVinculados={menoresVinculados}
            isLoadingMenorId={isLoadingMenorId}
            setIsLoadingMenorId={setIsLoadingMenorId}
            usuarioLogado={usuarioLogado}
            initialValuesIJM={initialValuesIJM}
            formikRef={formikRef}
            setMenorSelecionado={setMenorSelecionado}
            setUser={setUser}
            setResponsavelEncontrado={setResponsavelEncontrado}
            setIsUserVerified={setIsUserVerified}
            setShowIJMForm={setShowIJMForm}
            setShowIJMFormMenor={setShowIJMFormMenor}
            setPrecisaResponsavel={setPrecisaResponsavel}
            setEtapaAtual={setEtapaAtual}
            setMesmoCelular={setMesmoCelular}
            setMesmoEmail={setMesmoEmail}
            setDocumentoExistente={setDocumentoExistente}
            setDocumentoTutela={setDocumentoTutela}
            setDocumentoRemovido={setDocumentoRemovido}
            calcularIdade={calcularIdade}
            toast={toast}
            cadastrarNovoMenor={cadastrarNovoMenor}
            menoresJaMatriculadosIds={menoresJaMatriculadosRef.current}
          />

          <Paper sx={{
            p: '2rem',
            background: '#f9f9f9',
            '& .MuiInputBase-root': { backgroundColor: '#ffffff' },
            '& .MuiInputBase-root.Mui-disabled': { backgroundColor: '#ffffff' },
          }}>
            {etapaAtual !== 'login' && (
              <Button
                startIcon={<ArrowBack />}
                onClick={async () => {
                  const isDirty = etapaAtual === 'formulario' && formikRef.current?.dirty;
                  if (isDirty) {
                    const result = await Swal.fire({
                      title: 'Descartar alterações?',
                      text: 'Você tem dados preenchidos. Se voltar, eles serão perdidos.',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonText: 'Sim, voltar',
                      cancelButtonText: 'Continuar preenchendo',
                    });
                    if (!result.isConfirmed) return;
                  }
                  setIsNewUser(false);
                  setShowIJMForm(false);
                  setShowIJMFormMenor(false)
                  setUser(initialValues);
                  setEscolhaCadastro(null);
                  setPrecisaResponsavel(false);
                  setIdade(null);
                  setShowPopupEscolha(false);
                  setShowPopupAdulto(false);
                  setShowPopupMenorIdade(false);
                  setResponsavelEncontrado(null);
                  setMenorSelecionado(null);
                  setIsUserVerified(false);
                  setUserHasPassword(false);
                  setMesmoEndereco(false);
                  setMesmoCelular(false);
                  setMesmoTelefone(false);
                  setMesmoEmail(false);
                  setEnderecoConfirmado(false);
                  setEtapaAtual('login');
                  setConfirmedUserData(false);
                  menoresJaMatriculadosRef.current = [];
                }}
              >
                Voltar para login
              </Button>
            )}

            <Box textAlign='center'>
              <div dangerouslySetInnerHTML={{ __html: texts?.titulo }} />
              <div dangerouslySetInnerHTML={{ __html: texts?.subtitulo }} />
            </Box>

            <Box textAlign='left'>
              <div dangerouslySetInnerHTML={{ __html: texts?.descricao }} />
            </Box>

            {(() => {
              const etapaInfo = getEtapaInfo();
              return etapaInfo ? (
                <Box sx={{ mt: 3, mb: 2 }}>
                  <Typography variant='caption' color='text.secondary'>
                    {etapaInfo.label}
                  </Typography>
                  <LinearProgress
                    variant='determinate'
                    value={etapaInfo.value}
                    sx={{ mt: 0.5 }}
                  />
                </Box>
              ) : null;
            })()}

            {/* ✅ ETAPA 1: LOGIN */}
            {etapaAtual === 'login' && !isNewUser && !isUserVerified && (
              <Grid container spacing={3} sx={{ mt: 3 }}>
                <Grid item xs={12}>
                  <Typography variant='h4'>
                    Se você já tem um cadastro, entre com seu CPF ou e-mail e
                    senha. Caso não tenha cadastro,{' '}
                    <Tooltip title='clique para se cadastrar' arrow>
                      <Link
                        onClick={() => {
                          setIsNewUser(true);
                          setEtapaAtual('escolhaCadastro'); // ✅ Alterado para escolhaCadastro
                        }}
                        style={{
                          cursor: 'pointer',
                          color: '#7352c7',
                        }}
                      >
                        clique aqui para se cadastrar
                      </Link>
                    </Tooltip>
                  </Typography>
                </Grid>

                <Grid item lg={4} xs={12}>
                  <TextField
                    fullWidth
                    name='emailOrCpf'
                    label='Email ou CPF'
                    value={user.emailOrCpf || ''}
                    onChange={(e) => {
                      setUser((prev) => ({
                        ...prev,
                        emailOrCpf: formatCPF(e.target.value),
                      }));
                    }}
                  />
                </Grid>

                <Grid item lg={4} xs={12}>
                  <TextField
                    fullWidth
                    type={showPassword ? 'text' : 'password'}
                    name='senha'
                    value={user.senha || ''}
                    onChange={(e) => {
                      setUser((prev) => ({ ...prev, senha: e.target.value }));
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && user.emailOrCpf && user.senha) {
                        onSignIn(user.emailOrCpf, user.senha);
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton
                            onClick={() => setShowPassword((show) => !show)}
                            edge='end'
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    label='Senha'
                  />
                  <Box sx={{ mt: 0.5, textAlign: 'right' }}>
                    <Link to='/esqueci-senha' style={{ fontSize: '0.85rem', color: '#7352c7' }}>
                      Esqueci minha senha
                    </Link>
                  </Box>
                </Grid>

                <Grid
                  item
                  lg={4}
                  xs={12}
                  textAlign={{ xs: 'center', lg: 'initial' }}
                >
                  <LoadingButton
                    color='success'
                    variant='contained'
                    size='large'
                    loading={isLoadingLogin}
                    onClick={() => onSignIn(user.emailOrCpf, user.senha)}
                    sx={{ maxWidth: { md: '200px', mt: '1rem' } }}
                    disabled={!user.emailOrCpf || !user.senha}
                  >
                    Entrar
                  </LoadingButton>
                </Grid>
              </Grid>
            )}

            {/* ETAPA ESCOLHA: fallback caso o dialog seja fechado sem escolha */}
            {etapaAtual === 'escolha' && !showDialogOpcoes && (
              <Grid container spacing={3} sx={{ mt: 3 }}>
                <Grid item xs={12}>
                  <Alert severity='info' sx={{ mb: 2 }}>
                    Por favor, escolha uma das opções para continuar com sua matrícula.
                  </Alert>
                  <Button
                    variant='outlined'
                    onClick={() => setShowDialogOpcoes(true)}
                  >
                    Ver opções de matrícula
                  </Button>
                </Grid>
              </Grid>
            )}

            {/* ✅ NOVA ETAPA: ESCOLHA DE CADASTRO PARA NOVO USUÁRIO */}
            {etapaAtual === 'escolhaCadastro' && isNewUser && (
              <Grid container spacing={3} sx={{ mt: 3 }}>
                <Grid item xs={12}>
                  <Typography variant='h4' fontWeight='bold' gutterBottom>
                    Como deseja se cadastrar?
                  </Typography>
                  <Alert severity='info' sx={{ mb: 3 }}>
                    Escolha a opção que melhor se aplica a você:
                  </Alert>
                </Grid>

                {/* Opção 1: Cadastrar como responsável + menor */}
                <Grid item xs={12} md={6}>
                  <Card
                    sx={{
                      p: 3,
                      cursor: 'pointer',
                      border: escolhaCadastro === 'responsavelMenor' ? 2 : 1,
                      borderColor:
                        escolhaCadastro === 'responsavelMenor'
                          ? 'primary.main'
                          : 'divider',
                      '&:hover': { borderColor: 'primary.main' },
                    }}
                    onClick={() => {
                      // Item 7.2: cadastro do responsável fica numa etapa própria,
                      // separada do formulário do menor (setado só depois, em cadastrarNovoMenor)
                      setEscolhaCadastro('responsavelMenor');
                      setUser(initialValues);
                      setResponsavelEncontrado(null); // Responsável será novo
                      setMenorSelecionado(null);
                      setEtapaAtual('cadastroResponsavel');
                    }}
                  >
                    <Box display='flex' alignItems='center' gap={2}>
                      <Avatar sx={{ bgcolor: 'primary.main' }}>
                        <Groups />
                      </Avatar>
                      <Box>
                        <Typography variant='h6' fontWeight='bold'>
                          Sou responsável por um menor
                        </Typography>
                        <Typography color='textSecondary'>
                          Quero me cadastrar como responsável e cadastrar uma
                          criança/jovem
                        </Typography>
                      </Box>
                    </Box>
                  </Card>
                </Grid>

                {/* Opção 2: Cadastrar para curso de mocidade (18-24 anos) */}
                <Grid item xs={12} md={6}>
                  <Card
                    sx={{
                      p: 3,
                      cursor: 'pointer',
                      border: escolhaCadastro === 'mocidade' ? 2 : 1,
                      borderColor:
                        escolhaCadastro === 'mocidade'
                          ? 'primary.main'
                          : 'divider',
                      '&:hover': { borderColor: 'primary.main' },
                    }}
                    onClick={() => {
                      setEscolhaCadastro('mocidade');
                      setPrecisaResponsavel(false);
                      setShowIJMForm(true);
                      setShowIJMFormMenor(false);
                      setEtapaAtual('formulario');
                      setUser(initialValues);
                      setResponsavelEncontrado(null);

                      setTimeout(() => {
                        if (formikRef.current) {
                          formikRef.current.setValues(initialValues);
                        }
                      }, 100);
                    }}
                  >
                    <Box display='flex' alignItems='center' gap={2}>
                      <Avatar sx={{ bgcolor: 'success.main' }}>
                        <School />
                      </Avatar>
                      <Box>
                        <Typography variant='h6' fontWeight='bold'>
                          Fazer curso de Mocidade
                        </Typography>
                        <Typography color='textSecondary'>
                          Tenho entre 18 e 24 anos e quero me matricular
                        </Typography>
                        {/* <Typography variant='caption' color='warning.main' fontWeight='bold'>
                          Exclusivo para pessoas de 18 a 24 anos
                        </Typography> */}
                      </Box>
                    </Box>
                  </Card>
                </Grid>

                {/* Botão voltar */}
                <Grid item xs={12}>
                  <Button
                    startIcon={<ArrowBack />}
                    onClick={() => {
                      setIsNewUser(false);
                      setEtapaAtual('login');
                      setEscolhaCadastro(null);
                    }}
                  >
                    Voltar para login
                  </Button>
                </Grid>
              </Grid>
            )}

            {/* ✅ ETAPA — CADASTRO DO RESPONSÁVEL (item 7.2, novo usuário responsável) */}
            {etapaAtual === 'cadastroResponsavel' && (
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchemaCadastroResponsavel}
                onSubmit={(values, { setSubmitting, setFieldError }) =>
                  handleSubmitCadastroResponsavel(values, setFieldError, setSubmitting)
                }
              >
                {({ values, isSubmitting, handleChange, setFieldValue, errors }) => (
                  <Form style={{ width: '100%' }} noValidate autoComplete='off'>
                    <Grid container spacing={3} sx={{ mt: 3 }}>
                      <Grid item xs={12}>
                        <Typography variant='h4' fontWeight='bold' gutterBottom>
                          Cadastro do Responsável
                        </Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <FormularioCadastroResponsavelInicial
                          values={values}
                          setFieldValue={setFieldValue}
                          handleChange={handleChange}
                          isLoading={isLoading}
                          showPassword={showPassword}
                          showPasswordConfirmation={showPasswordConfirmation}
                          handleClickShowPassword={handleClickShowPassword}
                          handleClickShowPasswordConfirmation={handleClickShowPasswordConfirmation}
                          handleMouseDownPassword={handleMouseDownPassword}
                          handleMouseDownPasswordConfirmation={handleMouseDownPasswordConfirmation}
                          checkCep={checkCep}
                        />
                      </Grid>

                      <Grid item xs={12} sx={{ textAlign: 'center', mt: '1rem' }}>
                        <LoadingButton
                          color='success'
                          type='submit'
                          variant='contained'
                          size='large'
                          loading={isSubmitting}
                        >
                          Cadastrar e continuar
                        </LoadingButton>
                      </Grid>
                    </Grid>
                    {isSubmitting ? errorsHandler(errors) : null}
                  </Form>
                )}
              </Formik>
            )}

            {/* ✅ ETAPA 2: CONFIRMAÇÃO DADOS DO ADULTO (mantida) */}
            {etapaAtual === 'confirmarAdulto' && isUserVerified && (
              <Formik
                initialValues={{
                  ...(usuarioLogado || initialValues),
                  // email_confirmacao/celular_confirmacao nunca são salvos no banco —
                  // sem isso, todo usuário existente via pré-preenchidos com email/celular
                  // reais mas confirmação em branco, sendo obrigado a redigitar sem
                  // ter mudado nada. Só precisa reconfirmar se editar o valor de fato.
                  email_confirmacao: (usuarioLogado || initialValues).email || '',
                  celular_confirmacao: (usuarioLogado || initialValues).celular || '',
                }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting, setFieldError }) => {
                  confirmarDadosAdulto(values, setFieldError);
                  setSubmitting(false);
                }}
              >
                {({
                  values,
                  isSubmitting,
                  handleChange,
                  setFieldValue,
                  setFieldError,
                  touched,
                  setFieldTouched,
                  errors,
                }) => (
                  <Form style={{ width: '100%' }} noValidate autoComplete='off'>
                    <Grid container spacing={3} sx={{ mt: 3 }}>
                      <Grid item xs={12}>
                        <Typography variant='h4' fontWeight='bold' gutterBottom>
                          Confirme seus dados antes de continuar
                        </Typography>
                        <Alert severity='info' sx={{ mb: 3 }}>
                          Verifique se seus dados estão corretos. Exceto Nome e
                          CPF, você pode atualizar qualquer informação antes de
                          prosseguir.
                        </Alert>
                      </Grid>

                      <Grid item lg={6} xs={12}>
                        <Tooltip title='Nome não pode ser alterado' arrow>
                          <span>
                            <JumboTextField
                              fullWidth
                              name='nome'
                              label='Nome Completo'
                              value={values.nome || ''}
                              disabled={true}
                            />
                          </span>
                        </Tooltip>
                      </Grid>

                      <Grid item lg={6} xs={12}>
                        <JumboTextField
                          fullWidth
                          name='data_nascimento'
                          type='date'
                          label='Data de Nascimento'
                          value={values.data_nascimento || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          disabled={false}
                        />
                      </Grid>

                      <Grid item lg={4} xs={12}>
                        <JumboTextField
                          fullWidth
                          name='rg'
                          label='RG'
                          value={values.rg || ''}
                          onChange={handleChange}
                          disabled={false}
                        />
                      </Grid>
                      <Grid item lg={4} xs={12}>
                        <Tooltip title='CPF não pode ser alterado' arrow>
                          <span>
                            <InputMask
                              mask='999.999.999-99'
                              value={values.cpf || ''}
                              onChange={handleChange}
                              disabled={true}
                            >
                              {(inputProps) => (
                                <JumboTextField
                                  {...inputProps}
                                  id='cpf'
                                  fullWidth
                                  name='cpf'
                                  label='CPF'
                                  type='text'
                                  disabled={true}
                                />
                              )}
                            </InputMask>
                          </span>
                        </Tooltip>
                      </Grid>

                      <Grid item lg={6} xs={12}>
                        {verifyMask /* ||
                          updateInputValue(user, values, 'celular').replace(
                            /[^\d]/g,
                            ''
                          ).length === 14 */ ? (
                          <InputMask
                            mask={verifyMask ? '+999(99)99999-9999' : undefined}
                            maskPlaceholder={null}
                            error={touched.celular ? errors.celular : undefined}
                            touched={touched.celular}
                            value={updateInputValue(user, values, 'celular')}
                            onChange={handleChange}
                            disabled={confirmedUserData}
                            disabledUnderline={confirmedUserData}
                          >
                            {(inputProps) => (
                              <JumboTextField
                                {...inputProps}
                                fullWidth
                                name='celular'
                                label='Celular (DDI, DDD e número)'
                                      disabled={inputProps.disabledUnderline}
                                InputLabelProps={{ shrink: true }}
                              />
                            )}
                          </InputMask>
                        ) : (
                          <JumboTextField
                            fullWidth
                            name='celular'
                            label='Celular (DDI, DDD e número)'
                              InputLabelProps={{ shrink: true }}
                            value={updateInputValue(
                              user,
                              values,
                              'celular'
                            ).replace(/[^\d]/g, '')}
                            onChange={handleChange}
                            onBlur={() => setFieldTouched('celular', true)}
                            inputRef={celularInputRef}
                            disabled={confirmedUserData}
                          />
                        )}
                      </Grid>
                      <Grid item lg={6} xs={12}>
                        {verifyMask /* ||
                          updateInputValue(
                            user,
                            values,
                            'celular_confirmacao'
                          ).replace(/[^\d]/g, '').length === 14 */ ? (
                          <InputMask
                            mask={verifyMask ? '+999(99)99999-9999' : undefined}
                            maskPlaceholder={null}
                            value={updateInputValue(
                              user,
                              values,
                              'celular_confirmacao'
                            )}
                            onChange={handleChange}
                            onPaste={(e) => e.preventDefault()}
                            error={
                              touched.celular_confirmacao
                                ? errors.celular_confirmacao
                                : undefined
                            }
                            touched={touched.celular_confirmacao}
                            // onBlur={() => setTouched({'celular_confirmacao': true})}
                            onBlur={() =>
                              setFieldTouched('celular_confirmacao', true)
                            }
                            disabled={confirmedUserData}
                            disabledUnderline={confirmedUserData}
                          >
                            {(inputProps) => (
                              <JumboTextField
                                {...inputProps}
                                fullWidth
                                name='celular_confirmacao'
                                label='Confirmar celular (DDI, DDD e número)'
                                      disabled={inputProps.disabledUnderline}
                                InputLabelProps={{ shrink: true }}
                              />
                            )}
                          </InputMask>
                        ) : (
                          <JumboTextField
                            fullWidth
                            name='celular_confirmacao'
                            label='Confirmar celular (DDI, DDD e número)'
                              InputLabelProps={{ shrink: true }}
                            value={updateInputValue(
                              user,
                              values,
                              'celular_confirmacao'
                            ).replace(/[^\d]/g, '')}
                            onChange={handleChange}
                            onBlur={() =>
                              setFieldTouched('celular_confirmacao', true)
                            }
                            disabled={confirmedUserData}
                          />
                        )}
                      </Grid>

                      <Grid item lg={6} xs={12}>
                        <JumboTextField
                          fullWidth
                          name='email'
                          label='Email'
                          type='email'
                          value={updateInputValue(user, values, 'email')}
                          error={touched.email ? errors.email : undefined}
                          touched={+touched.email}
                          disabled={confirmedUserData}
                        />
                      </Grid>
                      <Grid item lg={6} xs={12}>
                        <JumboTextField
                          fullWidth
                          name='email_confirmacao'
                          label='Confirmar email'
                          type='email'
                          value={updateInputValue(
                            user,
                            values,
                            'email_confirmacao'
                          )}
                          disabled={confirmedUserData}
                          onPaste={(e) => e.preventDefault()}
                          onChange={handleChange}
                          error={
                            touched.email_confirmacao
                              ? errors.email_confirmacao
                              : undefined
                          }
                          touched={+touched.email_confirmacao}
                        />
                      </Grid>
                      <Grid item lg={lg ? 4 : 4} xs={12}>
                        <FormControl fullWidth>
                          <Select
                            options={COUNTRIES}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                            onChange={(pais) =>
                              setFieldValue('pais', pais.value)
                            }
                            value={COUNTRIES.filter(
                              (option) => option.value === values.pais
                            )}
                            placeholder='País'
                            isDisabled={confirmedUserData}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item lg={lg ? 8 : 8} xs={12}>
                        <Typography variant='h6' component='h6'>
                          Escolha no campo de seleção{' '}
                          {lg ? 'abaixo' : 'ao lado'} o País em que você mora
                          atualmente
                        </Typography>
                      </Grid>
                      {values.pais === 'BR' ? (
                        <>
                          <Grid item lg={2} xs={10}>
                            <InputMask
                              mask='99999-999'
                              value={updateInputValue(user, values, 'CEP')}
                              onChange={handleChange}
                              onBlur={(e) => checkCep(e, setFieldValue)}
                              disabled={confirmedUserData}
                              disabledUnderline={confirmedUserData}
                            >
                              {(inputProps) => (
                                <JumboTextField
                                  {...inputProps}
                                  fullWidth
                                  name='CEP'
                                  label='CEP'
                                          disabled={inputProps.disabledUnderline}
                                />
                              )}
                            </InputMask>
                          </Grid>
                          <Grid item lg={1} xs={1}>
                            {isLoading && (
                              <CircularProgress
                                style={{ alignSelf: 'center' }}
                              />
                            )}
                          </Grid>
                          <Grid item lg={7} xs={12}>
                            <JumboTextField
                              fullWidth
                              name='endereco'
                              label='Endereço'
                              value={updateInputValue(user, values, 'endereco')}
                                  disabled={confirmedUserData}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                          <Grid item lg={2} xs={4}>
                            <JumboTextField
                              fullWidth
                              name='numero'
                              label='Número'
                              value={updateInputValue(user, values, 'numero')}
                                  disabled={confirmedUserData}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                          <Grid item lg={3} xs={8}>
                            <JumboTextField
                              fullWidth
                              name='complemento'
                              label='Complemento'
                              value={updateInputValue(
                                user,
                                values,
                                'complemento'
                              )}
                                  disabled={confirmedUserData}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                          <Grid item lg={2} xs={6}>
                            <JumboTextField
                              fullWidth
                              name='bairro'
                              label='Bairro'
                              value={updateInputValue(user, values, 'bairro')}
                                  disabled={confirmedUserData}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>

                          <Grid item lg={2} xs={6}>
                            <FormControl fullWidth>
                              <InputLabel id='uf'>UF</InputLabel>
                              <JumboSelectField
                                labelId='uf'
                                id='uf'
                                name='uf'
                                value={updateInputValue(user, values, 'uf')}
                                label='UF'
                                      disabled={confirmedUserData}
                              >
                                <MenuItem value={'AC'}>Acre</MenuItem>
                                <MenuItem value={'AL'}>Alagoas</MenuItem>
                                <MenuItem value={'AP'}>Amapá</MenuItem>
                                <MenuItem value={'AM'}>Amazonas</MenuItem>
                                <MenuItem value={'BA'}>Bahia</MenuItem>
                                <MenuItem value={'CE'}>Ceará</MenuItem>
                                <MenuItem value={'DF'}>
                                  Distrito Federal
                                </MenuItem>
                                <MenuItem value={'ES'}>Espírito Santo</MenuItem>
                                <MenuItem value={'GO'}>Goiás</MenuItem>
                                <MenuItem value={'MA'}>Maranhão</MenuItem>
                                <MenuItem value={'MT'}>Mato Grosso</MenuItem>
                                <MenuItem value={'MS'}>
                                  Mato Grosso do Sul
                                </MenuItem>
                                <MenuItem value={'MG'}>Minas Gerais</MenuItem>
                                <MenuItem value={'PA'}>Pará</MenuItem>
                                <MenuItem value={'PB'}>Paraíba</MenuItem>
                                <MenuItem value={'PR'}>Paraná</MenuItem>
                                <MenuItem value={'PE'}>Pernambuco</MenuItem>
                                <MenuItem value={'PI'}>Piauí</MenuItem>
                                <MenuItem value={'RJ'}>Rio de Janeiro</MenuItem>
                                <MenuItem value={'RN'}>
                                  Rio Grande do Norte
                                </MenuItem>
                                <MenuItem value={'RS'}>
                                  Rio Grande do Sul
                                </MenuItem>
                                <MenuItem value={'RO'}>Rondônia</MenuItem>
                                <MenuItem value={'RR'}>Roraima</MenuItem>
                                <MenuItem value={'SC'}>Santa Catarina</MenuItem>
                                <MenuItem value={'SP'}>São Paulo</MenuItem>
                                <MenuItem value={'SE'}>Sergipe</MenuItem>
                                <MenuItem value={'TO'}>Tocantins</MenuItem>
                              </JumboSelectField>
                            </FormControl>
                          </Grid>
                          <Grid item lg={4} xs={6}>
                            <JumboTextField
                              fullWidth
                              name='cidade'
                              label='Cidade'
                              value={updateInputValue(user, values, 'cidade')}
                                  disabled={confirmedUserData}
                            />
                          </Grid>
                        </>
                      ) : (
                        <>
                          <Grid item xs={12}>
                            <JumboTextField
                              fullWidth
                              name='endereco'
                              label='Endereço'
                              value={updateInputValue(user, values, 'endereco')}
                                  disabled={confirmedUserData}
                            />
                          </Grid>
                          <Grid item lg={4} xs={6}>
                            <JumboTextField
                              fullWidth
                              name='codigo_postal'
                              label='Código Postal'
                              value={updateInputValue(
                                user,
                                values,
                                'codigo_postal'
                              )}
                                  disabled={confirmedUserData}
                            />
                          </Grid>
                          <Grid item lg={4} xs={6}>
                            <JumboTextField
                              fullWidth
                              name='estado'
                              label='Estado'
                              value={updateInputValue(user, values, 'estado')}
                                  disabled={confirmedUserData}
                            />
                          </Grid>
                        </>
                      )}

                      <Grid
                        item
                        xs={12}
                        sx={{ textAlign: 'center', mt: '1rem' }}
                      >
                        <LoadingButton
                          color='success'
                          type='submit'
                          variant='contained'
                          size='large'
                          loading={isSubmitting}
                        >
                          Atualize se desejar e clique para continuar
                        </LoadingButton>
                      </Grid>
                    </Grid>
                    {isSubmitting ? errorsHandler(errors) : null}
                    {verifyValidations(values)}
                  </Form>
                )}
              </Formik>
            )}

            {/* ✅ ETAPA 4: FORMULÁRIO FINAL */}
            {(etapaAtual === 'formulario' || (isNewUser && showIJMForm)) && (
              <Formik
                innerRef={formikRef}
                initialValues={
                  showIJMFormMenor ? initialValuesIJM : initialValues
                }
                validationSchema={validationSchema}
                enableReinitialize
                validateOnChange={false}
                onSubmit={handleSubmit}
                validateOnBlur
              >
                {({
                  values,
                  isSubmitting,
                  handleChange,
                  setFieldValue,
                  touched,
                  errors,
                  setFieldTouched,
                  setFieldError,
                }) => (
                  <Form style={{ width: '100%' }} noValidate autoComplete='off'>
                    {/* Header e Alertas */}
                    <Box sx={{ mt: 3, mb: 2 }}>
                      <Typography variant='h4' fontWeight='bold' gutterBottom>
                        {precisaResponsavel
                          ? responsavelEncontrado
                            ? 'Cadastro de Menor'
                            : 'Cadastro de Responsável e Menor'
                          : 'Cadastro para Mocidade'}
                      </Typography>

                      {etapaAtual === 'formulario' &&
                        isUserVerified &&
                        !isNewUser && (
                          <Alert severity='info' sx={{ mb: 2 }}>
                            {showIJMFormMenor
                              ? 'Preencha os dados do menor abaixo.'
                              : 'Seus dados já foram confirmados. Agora selecione a turma.'}
                          </Alert>
                        )}

                      {menorSelecionado && (
                        <Alert severity='warning' sx={{ mb: 2 }}>
                          <strong>Atenção:</strong> Você está editando dados
                          de um menor já cadastrado. Todas as alterações serão
                          salvas ao finalizar.
                        </Alert>
                      )}

                      {precisaResponsavel && !responsavelEncontrado && (
                        <Alert severity='info' sx={{ mb: 2 }}>
                          <strong>Novo cadastro:</strong> Você está se
                          cadastrando como responsável e cadastrando um menor
                          ao mesmo tempo.
                        </Alert>
                      )}

                    </Box>

                    {/* Card próprio para o Responsável já identificado — separado do card do
                        menor para deixar claro que esses dados são do responsável, não do menor */}
                    {precisaResponsavel && responsavelEncontrado && (
                      <Card variant='outlined' sx={{ mb: 2, borderColor: 'success.main' }}>
                        <CardContent>
                          <Box display='flex' alignItems='center' gap={1} mb={2}>
                            <FamilyRestroom color='success' />
                            <Typography variant='h6' fontWeight='bold'>
                              Responsável por este cadastro
                            </Typography>
                          </Box>

                          <Grid container spacing={2} alignItems='flex-start'>
                            <Grid item xs={12} md={5}>
                              <TextField
                                fullWidth
                                label='Responsável'
                                value={responsavelEncontrado.nome || ''}
                                disabled
                                InputLabelProps={{ shrink: true }}
                                helperText={
                                  responsavelEncontrado.cpf
                                    ? `CPF: ${responsavelEncontrado.cpf}`
                                    : ' '
                                }
                                sx={{
                                  '& .MuiOutlinedInput-root fieldset': {
                                    borderColor: 'success.main',
                                    borderWidth: 2,
                                  },
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <FormControl fullWidth>
                                <InputLabel shrink id='grau_parentesco_resp_encontrado'>
                                  Grau de Parentesco *
                                </InputLabel>
                                <JumboSelectField
                                  fullWidth
                                  labelId='grau_parentesco_resp_encontrado'
                                  id='grau_parentesco_resp_encontrado'
                                  name='grau_parentesco'
                                  label='Grau de Parentesco *'
                                  notched
                                >
                                  <MenuItem value=''>Selecione</MenuItem>
                                  <MenuItem value='pai'>Pai/Padrasto</MenuItem>
                                  <MenuItem value='mae'>Mãe/Madrasta</MenuItem>
                                  <MenuItem value='avo'>Avô/Avó</MenuItem>
                                  <MenuItem value='tio'>Tio/Tia</MenuItem>
                                  <MenuItem value='irmao'>Irmão/Irmã</MenuItem>
                                  <MenuItem value='representante_legal'>
                                    Representante Legal
                                  </MenuItem>
                                  <MenuItem value='outro'>Outro</MenuItem>
                                </JumboSelectField>
                              </FormControl>
                            </Grid>
                            {values.grau_parentesco === 'representante_legal' && (
                              <Grid item xs={12}>
                                <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
                                  Documento de guarda/tutela (obrigatório para Representante Legal)
                                </Typography>
                                {renderDocumentoTutela()}
                              </Grid>
                            )}
                          </Grid>
                        </CardContent>
                      </Card>
                    )}

                    {/* Accordion 1: Dados do Responsável */}
                    {precisaResponsavel && !responsavelEncontrado && (
                      <Accordion defaultExpanded sx={{ mb: 2 }}>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                          <Typography variant='h5' fontWeight='bold'>Dados do Responsável</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container spacing={3}>
                            <FormularioResponsavelNovo
                              values={values}
                              setFieldValue={setFieldValue}
                              handleChange={handleChange}
                              precisaResponsavel={precisaResponsavel}
                              responsavelEncontrado={responsavelEncontrado}
                              confirmedUserData={confirmedUserData}
                              isLoading={isLoading}
                              mostrarSenhaResponsavel={mostrarSenhaResponsavel}
                              mostrarSenhaConfirmacaoResponsavel={mostrarSenhaConfirmacaoResponsavel}
                              handleClickShowSenhaResponsavel={handleClickShowSenhaResponsavel}
                              handleClickShowSenhaConfirmacaoResponsavel={handleClickShowSenhaConfirmacaoResponsavel}
                              handleMouseDownPassword={handleMouseDownPassword}
                              handleMouseDownPasswordConfirmation={handleMouseDownPasswordConfirmation}
                              checkCepResp={checkCepResp}
                            />
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    )}

                    {/* Accordion 2: Dados Pessoais */}
                    <Accordion defaultExpanded sx={{ mb: 2 }}>
                      <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography variant='h5' fontWeight='bold'>
                          {precisaResponsavel ? 'Dados do Menor' : 'Seus Dados'}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={3}>

                      <Grid item lg={4} xs={12}>
                        <JumboTextField
                          fullWidth
                          name='nome'
                          label={`Nome Completo ${
                            precisaResponsavel ? 'do Menor' : ''
                          } *`}
                          value={values.nome || ''}
                          disabled={getCampoDisabled('nome', showIJMFormMenor)}
                          helperText={
                            menorSelecionado && showIJMFormMenor
                              ? 'Você pode editar o nome do menor'
                              : undefined
                          }
                        />
                      </Grid>

                      <Grid item lg={2} xs={12}>
                        <JumboTextField
                          fullWidth
                          name='data_nascimento'
                          type='date'
                          label='Data de Nascimento'
                          value={values.data_nascimento || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            handleChange(e);
                            setFieldValue('data_nascimento', e.target.value);
                          }}
                          onBlur={(e) =>
                            handleDataNascimentoBlur(e, setFieldValue)
                          }
                          disabled={getCampoDisabled(
                            'data_nascimento',
                            showIJMFormMenor
                          )}
                        />
                      </Grid>

                      <Grid item lg={3} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id='genero' shrink>{precisaResponsavel ? 'Gênero do Menor' : 'Gênero'}</InputLabel>
                          <JumboSelectField
                            fullWidth
                            id='genero'
                            name='genero'
                            label={precisaResponsavel ? 'Gênero do Menor' : 'Gênero'}
                            value={values.genero || ''}
                            onChange={handleChange}
                            notched
                          >
                            <MenuItem value=''>Selecione</MenuItem>
                            <MenuItem value='masculino'>Masculino</MenuItem>
                            <MenuItem value='feminino'>Feminino</MenuItem>
                            <MenuItem value='outro'>Outro</MenuItem>
                            <MenuItem value='prefiro_nao_informar'>Prefiro não informar</MenuItem>
                          </JumboSelectField>
                        </FormControl>
                      </Grid>

                      {/* Grau de parentesco: quando o responsável já foi identificado, o campo
                          fica no bloco "Responsável" acima do accordion; aqui só aparece para
                          responsável novo (ainda sem esse bloco). */}
                      {precisaResponsavel && !responsavelEncontrado && (
                        <Grid item lg={3} xs={12}>
                          <FormControl fullWidth>
                            <InputLabel id='grau_parentesco' shrink>Grau de Parentesco</InputLabel>
                            <JumboSelectField
                              fullWidth
                              id='grau_parentesco'
                              name='grau_parentesco'
                              label='Grau de Parentesco'
                              notched
                            >
                              <MenuItem value=''>Selecione</MenuItem>
                              <MenuItem value='pai'>Pai/Padrasto</MenuItem>
                              <MenuItem value='mae'>Mãe/Madrasta</MenuItem>
                              <MenuItem value='avo'>Avô/Avó</MenuItem>
                              <MenuItem value='tio'>Tio/Tia</MenuItem>
                              <MenuItem value='irmao'>Irmão/Irmã</MenuItem>
                              <MenuItem value='representante_legal'>
                                Representante Legal
                              </MenuItem>
                              <MenuItem value='outro'>Outro</MenuItem>
                            </JumboSelectField>
                          </FormControl>
                        </Grid>
                      )}

                      {precisaResponsavel && !responsavelEncontrado && values.grau_parentesco === 'representante_legal' && (
                        <Grid item xs={12}>
                          <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
                            Documento de guarda/tutela (obrigatório para Representante Legal)
                          </Typography>
                          {renderDocumentoTutela()}
                        </Grid>
                      )}

                      {/* RG do menor (específico) */}
                      {showIJMFormMenor && (
                        <Grid item lg={5} xs={12}>
                          <JumboTextField
                            fullWidth
                            name='rg_menor'
                            label='RG do Menor'
                            value={values.rg_menor || ''}
                              onChange={handleChange}
                            disabled={false}
                            placeholder='RG do menor (opcional)'
                          />
                        </Grid>
                      )}

                      <Grid item lg={4} xs={12}>
                        <Tooltip
                          title={menorSelecionado && showIJMFormMenor ? 'CPF de menor existente não pode ser alterado' : ''}
                          arrow
                        >
                        <span>
                        {isUserVerified ? (
                          <InputMask
                            mask='999.999.999-99'
                            value={updateInputValue(user, values, 'cpf')}
                            onChange={handleChange}
                            disabled={getCampoDisabled('cpf', showIJMFormMenor)}
                          >
                            {(inputProps) => (
                              <JumboTextField
                                {...inputProps}
                                id='cpf'
                                fullWidth
                                name='cpf'
                                label='CPF'
                                type='text'
                                      disabled={inputProps.disabled}
                                helperText={
                                  menorSelecionado && showIJMFormMenor
                                    ? 'CPF de menor existente não pode ser alterado'
                                    : undefined
                                }
                              />
                            )}
                          </InputMask>
                        ) : (
                          <InputMask
                            mask='999.999.999-99'
                            value={updateInputValue(user, values, 'cpf')}
                            onChange={handleChange}
                            disabled={confirmedUserData}
                          >
                            {(inputProps) => (
                              <JumboTextField
                                {...inputProps}
                                id='cpf'
                                fullWidth
                                name='cpf'
                                label='CPF'
                                type='text'
                                      disabled={inputProps.disabled}
                              />
                            )}
                          </InputMask>
                        )}
                        </span>
                        </Tooltip>
                      </Grid>

                      <Grid item lg={4} xs={12}>
                        {verifyMask ? (
                          <InputMask
                            mask={verifyMask ? '+999(99)99999-9999' : undefined}
                            maskPlaceholder={null}
                            error={touched.celular ? errors.celular : undefined}
                            touched={touched.celular}
                            value={updateInputValue(user, values, 'celular')}
                            onChange={handleChange}
                            disabled={
                              mesmoCelular || (precisaResponsavel ? false : confirmedUserData)
                            }
                            disabledUnderline={
                              mesmoCelular || (precisaResponsavel ? false : confirmedUserData)
                            }
                          >
                            {(inputProps) => (
                              <JumboTextField
                                {...inputProps}
                                fullWidth
                                name='celular'
                                label={showIJMFormMenor ? 'Celular (opcional)' : 'Celular (DDI, DDD e número)'}
                                      disabled={inputProps.disabledUnderline}
                                InputLabelProps={{ shrink: true }}
                                helperText={
                                  mesmoCelular
                                    ? 'Usando mesmo celular do responsável'
                                    : showIJMFormMenor
                                    ? 'Se não informado, o celular do responsável será utilizado'
                                    : ''
                                }
                              />
                            )}
                          </InputMask>
                        ) : (
                          <JumboTextField
                            fullWidth
                            name='celular'
                            label={showIJMFormMenor ? 'Celular (opcional)' : 'Celular (DDI, DDD e número)'}
                              InputLabelProps={{ shrink: true }}
                            value={updateInputValue(
                              user,
                              values,
                              'celular'
                            ).replace(/[^\d]/g, '')}
                            onChange={handleChange}
                            onBlur={() => setFieldTouched('celular', true)}
                            inputRef={celularInputRef}
                            disabled={
                              mesmoCelular || (precisaResponsavel ? false : confirmedUserData)
                            }
                            helperText={
                              mesmoCelular
                                ? 'Usando mesmo celular do responsável'
                                : showIJMFormMenor
                                ? 'Se não informado, o celular do responsável será utilizado'
                                : ''
                            }
                          />
                        )}
                        {showIJMFormMenor && (responsavelEncontrado?.celular || (precisaResponsavel && !responsavelEncontrado && values.celular_responsavel?.replace(/\D/g, '') !== '05511' && values.celular_responsavel?.replace(/\D/g, ''))) && (
                          <FormControlLabel
                            sx={{ mt: 0.5 }}
                            control={
                              <Checkbox
                                checked={mesmoCelular}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setMesmoCelular(checked);
                                  const celularFonte = responsavelEncontrado?.celular || values.celular_responsavel;
                                  // Marcado: exibe o celular do responsável (campo desabilitado);
                                  // o backend grava o sentinela. Desmarcado: limpa para edição.
                                  if (checked) {
                                    setFieldValue('celular', celularFonte);
                                    setFieldValue('celular_confirmacao', celularFonte);
                                  } else {
                                    setFieldValue('celular', '05511');
                                    setFieldValue('celular_confirmacao', '');
                                  }
                                }}
                              />
                            }
                            label={`Usar celular do responsável (${responsavelEncontrado?.celular || values.celular_responsavel})`}
                          />
                        )}
                      </Grid>
                      <Grid item lg={4} xs={12}>
                        {verifyMask ? (
                          <InputMask
                            mask={verifyMask ? '+999(99)99999-9999' : undefined}
                            maskPlaceholder={null}
                            value={updateInputValue(
                              user,
                              values,
                              'celular_confirmacao'
                            )}
                            onChange={handleChange}
                            onPaste={(e) => e.preventDefault()}
                            error={
                              touched.celular_confirmacao
                                ? errors.celular_confirmacao
                                : undefined
                            }
                            touched={touched.celular_confirmacao}
                            onBlur={() =>
                              setFieldTouched('celular_confirmacao', true)
                            }
                            disabled={
                              mesmoCelular || (precisaResponsavel ? false : confirmedUserData)
                            }
                            disabledUnderline={
                              mesmoCelular || (precisaResponsavel ? false : confirmedUserData)
                            }
                          >
                            {(inputProps) => (
                              <JumboTextField
                                {...inputProps}
                                fullWidth
                                name='celular_confirmacao'
                                label={showIJMFormMenor ? 'Confirmar celular (opcional)' : 'Confirmar celular (DDI, DDD e número)'}
                                      disabled={inputProps.disabledUnderline}
                                InputLabelProps={{ shrink: true }}
                                helperText={
                                  mesmoCelular
                                    ? 'Usando mesmo celular do responsável'
                                    : ''
                                }
                              />
                            )}
                          </InputMask>
                        ) : (
                          <JumboTextField
                            fullWidth
                            name='celular_confirmacao'
                            label={showIJMFormMenor ? 'Confirmar celular (opcional)' : 'Confirmar celular (DDI, DDD e número)'}
                              InputLabelProps={{ shrink: true }}
                            value={updateInputValue(
                              user,
                              values,
                              'celular_confirmacao'
                            ).replace(/[^\d]/g, '')}
                            onChange={handleChange}
                            onBlur={() =>
                              setFieldTouched('celular_confirmacao', true)
                            }
                            disabled={
                              mesmoCelular || (precisaResponsavel ? false : confirmedUserData)
                            }
                            helperText={
                              mesmoCelular
                                ? 'Usando mesmo celular do responsável'
                                : ''
                            }
                          />
                        )}
                      </Grid>

                      <Grid item lg={4} xs={12}>
                        <JumboTextField
                          fullWidth
                          name='telefone'
                          label='Telefone Fixo (DDI, DDD e número)'
                          InputLabelProps={{ shrink: true }}
                          value={updateInputValue(user, values, 'telefone')}
                          onChange={handleChange}
                          disabled={
                            precisaResponsavel
                              ? false
                              : confirmedUserData || mesmoTelefone
                          }
                          helperText={
                            mesmoTelefone
                              ? 'Usando mesmo telefone do responsável'
                              : ''
                          }
                        />
                      </Grid>

                      <Grid item lg={6} xs={12}>
                        <JumboTextField
                          fullWidth
                          name='email'
                          label={showIJMFormMenor ? 'Email (opcional)' : 'Email'}
                          type='email'
                          value={updateInputValue(user, values, 'email')}
                          error={touched.email ? errors.email : undefined}
                          touched={+touched.email}
                          disabled={
                            mesmoEmail || (precisaResponsavel
                              ? false
                              : confirmedUserData ||
                                (showIJMFormMenor &&
                                  responsavelEncontrado?.email))
                          }
                          helperText={
                            showIJMFormMenor && responsavelEncontrado?.email
                              ? 'Usando email do responsável'
                              : showIJMFormMenor
                              ? 'Se não informado, as comunicações serão enviadas ao responsável'
                              : undefined
                          }
                        />
                        {showIJMFormMenor && (responsavelEncontrado?.email || (precisaResponsavel && !responsavelEncontrado && values.email_responsavel)) && (
                          <FormControlLabel
                            sx={{ mt: 0.5 }}
                            control={
                              <Checkbox
                                checked={mesmoEmail}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setMesmoEmail(checked);
                                  const emailFonte = responsavelEncontrado?.email || values.email_responsavel;
                                  if (checked) {
                                    setFieldValue('email', emailFonte);
                                    setFieldValue('email_confirmacao', emailFonte);
                                  } else {
                                    setFieldValue('email', '');
                                    setFieldValue('email_confirmacao', '');
                                  }
                                }}
                              />
                            }
                            label={`Usar email do responsável (${responsavelEncontrado?.email || values.email_responsavel})`}
                          />
                        )}
                      </Grid>

                      <Grid item lg={6} xs={12}>
                        <JumboTextField
                          fullWidth
                          name='email_confirmacao'
                          label={showIJMFormMenor ? 'Confirmar email (opcional)' : 'Confirmar email'}
                          type='email'
                          value={updateInputValue(
                            user,
                            values,
                            'email_confirmacao'
                          )}
                          disabled={
                            mesmoEmail || (precisaResponsavel
                              ? false
                              : confirmedUserData ||
                                (showIJMFormMenor &&
                                  responsavelEncontrado?.email))
                          }
                          onPaste={(e) => e.preventDefault()}
                          onChange={handleChange}
                          error={
                            touched.email_confirmacao
                              ? errors.email_confirmacao
                              : undefined
                          }
                          touched={+touched.email_confirmacao}
                          helperText={
                            showIJMFormMenor && responsavelEncontrado?.email
                              ? 'Usando email do responsável'
                              : undefined
                          }
                        />
                      </Grid>

                      {/* Checkbox: usar endereço do responsável (só aparece se houver de onde herdar) */}
                      {showIJMFormMenor &&
                        (responsavelEncontrado?.endereco ||
                          (precisaResponsavel &&
                            !responsavelEncontrado &&
                            values.endereco_responsavel)) && (
                          <Grid item xs={12}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={mesmoEndereco}
                                  onChange={(e) => {
                                    const checked = e.target.checked;
                                    setMesmoEndereco(checked);
                                    const fonte = responsavelEncontrado || {
                                      endereco: values.endereco_responsavel,
                                      numero: values.numero_responsavel,
                                      complemento:
                                        values.complemento_responsavel,
                                      bairro: values.bairro_responsavel,
                                      cidade: values.cidade_responsavel,
                                      uf: values.uf_responsavel,
                                      CEP: values.CEP_responsavel,
                                      pais: values.pais_responsavel,
                                    };
                                    if (checked) {
                                      setFieldValue('endereco', fonte.endereco || '');
                                      setFieldValue('numero', fonte.numero || '');
                                      setFieldValue('complemento', fonte.complemento || '');
                                      setFieldValue('bairro', fonte.bairro || '');
                                      setFieldValue('cidade', fonte.cidade || '');
                                      setFieldValue('uf', fonte.uf || '');
                                      setFieldValue('CEP', fonte.CEP || '');
                                      setFieldValue('pais', fonte.pais || 'BR');
                                      setEnderecoConfirmado(true);
                                    } else {
                                      setFieldValue('endereco', '');
                                      setFieldValue('numero', '');
                                      setFieldValue('complemento', '');
                                      setFieldValue('bairro', '');
                                      setFieldValue('cidade', '');
                                      setFieldValue('uf', '');
                                      setFieldValue('CEP', '');
                                      setEnderecoConfirmado(false);
                                    }
                                  }}
                                />
                              }
                              label={`Usar endereço do responsável (${
                                responsavelEncontrado?.cidade ||
                                values.cidade_responsavel ||
                                ''
                              }${
                                (responsavelEncontrado?.uf ||
                                  values.uf_responsavel)
                                  ? ' - ' +
                                    (responsavelEncontrado?.uf ||
                                      values.uf_responsavel)
                                  : ''
                              })`}
                            />
                          </Grid>
                        )}

                      {/* Seção de endereço (sempre visível; desabilitada quando herdada do responsável) */}
                      <>
                          <Grid item lg={lg ? 4 : 4} xs={12}>
                            <FormControl fullWidth>
                              <Select
                                options={COUNTRIES}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                onChange={(pais) =>
                                  setFieldValue('pais', pais.value)
                                }
                                value={COUNTRIES.filter(
                                  (option) => option.value === values.pais
                                )}
                                placeholder='País'
                                isDisabled={
                                  mesmoEndereco || (!precisaResponsavel && confirmedUserData)
                                }
                              />
                            </FormControl>
                          </Grid>
                          <Grid item lg={lg ? 8 : 8} xs={12}>
                            <Typography variant='h6' component='h6'>
                              Escolha no campo de seleção{' '}
                              {lg ? 'abaixo' : 'ao lado'} o País em que você
                              mora atualmente
                            </Typography>
                          </Grid>
                          {values.pais === 'BR' ? (
                            <>
                              <Grid item lg={2} xs={10}>
                                <InputMask
                                  mask='99999-999'
                                  value={updateInputValue(user, values, 'CEP')}
                                  onChange={handleChange}
                                  onBlur={(e) => checkCep(e, setFieldValue)}
                                  disabled={
                                    mesmoEndereco || (!precisaResponsavel && confirmedUserData)
                                  }
                                  disabledUnderline={
                                    mesmoEndereco || (!precisaResponsavel && confirmedUserData)
                                  }
                                >
                                  {(inputProps) => (
                                    <JumboTextField
                                      {...inputProps}
                                      fullWidth
                                      name='CEP'
                                      label='CEP'
                                                  disabled={inputProps.disabledUnderline}
                                      helperText={
                                        mesmoEndereco
                                          ? 'Usando mesmo endereço do responsável'
                                          : ''
                                      }
                                    />
                                  )}
                                </InputMask>
                              </Grid>
                              <Grid item lg={1} xs={1}>
                                {isLoading && (
                                  <CircularProgress
                                    style={{ alignSelf: 'center' }}
                                  />
                                )}
                              </Grid>
                              <Grid item lg={7} xs={12}>
                                <JumboTextField
                                  fullWidth
                                  name='endereco'
                                  label='Endereço'
                                  value={updateInputValue(
                                    user,
                                    values,
                                    'endereco'
                                  )}
                                          disabled={
                                    mesmoEndereco || (!precisaResponsavel && confirmedUserData)
                                  }
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  helperText={
                                    mesmoEndereco
                                      ? 'Usando mesmo endereço do responsável'
                                      : ''
                                  }
                                />
                              </Grid>
                              <Grid item lg={2} xs={4}>
                                <JumboTextField
                                  fullWidth
                                  name='numero'
                                  label='Número'
                                  value={updateInputValue(
                                    user,
                                    values,
                                    'numero'
                                  )}
                                          disabled={
                                    mesmoEndereco || (!precisaResponsavel && confirmedUserData)
                                  }
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  helperText={
                                    mesmoEndereco
                                      ? 'Usando mesmo endereço do responsável'
                                      : ''
                                  }
                                />
                              </Grid>
                              <Grid item lg={3} xs={8}>
                                <JumboTextField
                                  fullWidth
                                  name='complemento'
                                  label='Complemento'
                                  value={updateInputValue(
                                    user,
                                    values,
                                    'complemento'
                                  )}
                                          disabled={
                                    mesmoEndereco || (!precisaResponsavel && confirmedUserData)
                                  }
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  helperText={
                                    mesmoEndereco
                                      ? 'Usando mesmo endereço do responsável'
                                      : ''
                                  }
                                />
                              </Grid>
                              <Grid item lg={2} xs={6}>
                                <JumboTextField
                                  fullWidth
                                  name='bairro'
                                  label='Bairro'
                                  value={updateInputValue(
                                    user,
                                    values,
                                    'bairro'
                                  )}
                                          disabled={
                                    mesmoEndereco || (!precisaResponsavel && confirmedUserData)
                                  }
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  helperText={
                                    mesmoEndereco
                                      ? 'Usando mesmo endereço do responsável'
                                      : ''
                                  }
                                />
                              </Grid>

                              <Grid item lg={2} xs={6}>
                                <FormControl fullWidth>
                                  <InputLabel id='uf'>UF</InputLabel>
                                  <JumboSelectField
                                    labelId='uf'
                                    id='uf'
                                    name='uf'
                                    value={updateInputValue(user, values, 'uf')}
                                    label='UF'
                                              disabled={
                                      mesmoEndereco || (!precisaResponsavel && confirmedUserData)
                                    }
                                  >
                                    <MenuItem value={'AC'}>Acre</MenuItem>
                                    <MenuItem value={'AL'}>Alagoas</MenuItem>
                                    <MenuItem value={'AP'}>Amapá</MenuItem>
                                    <MenuItem value={'AM'}>Amazonas</MenuItem>
                                    <MenuItem value={'BA'}>Bahia</MenuItem>
                                    <MenuItem value={'CE'}>Ceará</MenuItem>
                                    <MenuItem value={'DF'}>
                                      Distrito Federal
                                    </MenuItem>
                                    <MenuItem value={'ES'}>
                                      Espírito Santo
                                    </MenuItem>
                                    <MenuItem value={'GO'}>Goiás</MenuItem>
                                    <MenuItem value={'MA'}>Maranhão</MenuItem>
                                    <MenuItem value={'MT'}>
                                      Mato Grosso
                                    </MenuItem>
                                    <MenuItem value={'MS'}>
                                      Mato Grosso do Sul
                                    </MenuItem>
                                    <MenuItem value={'MG'}>
                                      Minas Gerais
                                    </MenuItem>
                                    <MenuItem value={'PA'}>Pará</MenuItem>
                                    <MenuItem value={'PB'}>Paraíba</MenuItem>
                                    <MenuItem value={'PR'}>Paraná</MenuItem>
                                    <MenuItem value={'PE'}>Pernambuco</MenuItem>
                                    <MenuItem value={'PI'}>Piauí</MenuItem>
                                    <MenuItem value={'RJ'}>
                                      Rio de Janeiro
                                    </MenuItem>
                                    <MenuItem value={'RN'}>
                                      Rio Grande do Norte
                                    </MenuItem>
                                    <MenuItem value={'RS'}>
                                      Rio Grande do Sul
                                    </MenuItem>
                                    <MenuItem value={'RO'}>Rondônia</MenuItem>
                                    <MenuItem value={'RR'}>Roraima</MenuItem>
                                    <MenuItem value={'SC'}>
                                      Santa Catarina
                                    </MenuItem>
                                    <MenuItem value={'SP'}>São Paulo</MenuItem>
                                    <MenuItem value={'SE'}>Sergipe</MenuItem>
                                    <MenuItem value={'TO'}>Tocantins</MenuItem>
                                  </JumboSelectField>
                                </FormControl>
                              </Grid>
                              <Grid item lg={4} xs={6}>
                                <JumboTextField
                                  fullWidth
                                  name='cidade'
                                  label='Cidade'
                                  value={updateInputValue(
                                    user,
                                    values,
                                    'cidade'
                                  )}
                                          disabled={
                                    mesmoEndereco || (!precisaResponsavel && confirmedUserData)
                                  }
                                  helperText={
                                    mesmoEndereco
                                      ? 'Usando mesmo endereço do responsável'
                                      : ''
                                  }
                                />
                              </Grid>
                            </>
                          ) : (
                            <>
                              <Grid item xs={12}>
                                <JumboTextField
                                  fullWidth
                                  name='endereco'
                                  label='Endereço'
                                  value={updateInputValue(
                                    user,
                                    values,
                                    'endereco'
                                  )}
                                          disabled={
                                    mesmoEndereco || (!precisaResponsavel && confirmedUserData)
                                  }
                                  helperText={
                                    mesmoEndereco
                                      ? 'Usando mesmo endereço do responsável'
                                      : ''
                                  }
                                />
                              </Grid>
                              <Grid item lg={4} xs={6}>
                                <JumboTextField
                                  fullWidth
                                  name='codigo_postal'
                                  label='Código Postal'
                                  value={updateInputValue(
                                    user,
                                    values,
                                    'codigo_postal'
                                  )}
                                          disabled={
                                    mesmoEndereco || (!precisaResponsavel && confirmedUserData)
                                  }
                                  helperText={
                                    mesmoEndereco
                                      ? 'Usando mesmo endereço do responsável'
                                      : ''
                                  }
                                />
                              </Grid>
                              <Grid item lg={4} xs={6}>
                                <JumboTextField
                                  fullWidth
                                  name='estado'
                                  label='Estado'
                                  value={updateInputValue(
                                    user,
                                    values,
                                    'estado'
                                  )}
                                          disabled={
                                    mesmoEndereco || (!precisaResponsavel && confirmedUserData)
                                  }
                                  helperText={
                                    mesmoEndereco
                                      ? 'Usando mesmo endereço do responsável'
                                      : ''
                                  }
                                />
                              </Grid>
                            </>
                          )}
                        </>

                      {/* Senha apenas para novo usuário adulto Mocidade */}
                      {isNewUser && !showIJMFormMenor && (
                        <>
                          <Grid item xs={12}>
                            <Typography variant='h5'>
                              Crie uma senha de acesso:
                            </Typography>
                          </Grid>
                          <Grid item lg={5} xs={12}>
                            <JumboTextField
                              fullWidth
                              id='senha'
                              type={showPassword ? 'text' : 'password'}
                              name='senha'
                              value={values.senha}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position='end'>
                                    <IconButton
                                      aria-label='toggle password visibility'
                                      onClick={handleClickShowPassword}
                                      onMouseDown={handleMouseDownPassword}
                                      edge='end'
                                    >
                                      {showPassword ? (
                                        <VisibilityOff />
                                      ) : (
                                        <Visibility />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                              InputLabelProps={{ shrink: true }}
                                  label='Senha *'
                              onBlur={() => setFieldTouched('senha', true)}
                            />
                          </Grid>
                          <Grid item lg={5} xs={12}>
                            <JumboTextField
                              fullWidth
                              id='senhaConfirmacao'
                              type={showPasswordConfirmation ? 'text' : 'password'}
                              name='senhaConfirmacao'
                              onPaste={(e) => e.preventDefault()}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position='end'>
                                    <IconButton
                                      aria-label='toggle password visibility'
                                      onClick={handleClickShowPasswordConfirmation}
                                      onMouseDown={handleMouseDownPasswordConfirmation}
                                      edge='end'
                                    >
                                      {showPasswordConfirmation ? (
                                        <VisibilityOff />
                                      ) : (
                                        <Visibility />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                              InputLabelProps={{ shrink: true }}
                                  label='Confirmar senha *'
                              onBlur={() => setFieldTouched('senhaConfirmacao', true)}
                            />
                          </Grid>
                        </>
                      )}

                    </Grid>
                    </AccordionDetails>
                    </Accordion>

                    {/* Accordion 3: Histórico Médico */}
                    {showIJMFormMenor && (
                      <Accordion defaultExpanded sx={{ mb: 2 }}>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                          <Typography variant='h5' fontWeight='bold'>Histórico Médico</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <CheckboxSection
                              title='O aluno apresenta alguma deficiência?'
                              options={opcoesDeficiencias}
                              selectedValues={values.deficiencias}
                              fieldName='deficiencias'
                              otherFieldName='outra_deficiencia'
                              values={values}
                              setFieldValue={setFieldValue}
                              handleChange={handleChange}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <CheckboxSection
                              title='O aluno possui alguma alergia?'
                              options={opcoesAlergias}
                              selectedValues={values.alergias}
                              fieldName='alergias'
                              otherFieldName='outra_alergia'
                              values={values}
                              setFieldValue={setFieldValue}
                              handleChange={handleChange}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <CheckboxSection
                              title='O aluno possui algum problema de saúde?'
                              options={opcoesProblemasSaude}
                              selectedValues={values.problemas_saude}
                              fieldName='problemas_saude'
                              otherFieldName='outro_problema_saude'
                              values={values}
                              setFieldValue={setFieldValue}
                              handleChange={handleChange}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <CheckboxSection
                              title='O aluno possui algum transtorno?'
                              options={opcoesTranstornos}
                              selectedValues={values.transtornos}
                              fieldName='transtornos'
                              otherFieldName='outro_transtorno'
                              values={values}
                              setFieldValue={setFieldValue}
                              handleChange={handleChange}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={values.medicacao_continua}
                                  onChange={(e) => setFieldValue('medicacao_continua', e.target.checked)}
                                  name='medicacao_continua'
                                />
                              }
                              label='O aluno faz uso de medicação contínua?'
                            />
                          </Grid>
                          {values.medicacao_continua && (
                            <Grid item xs={12}>
                              <JumboTextField
                                fullWidth
                                name='medicamentos'
                                label='Quais medicamentos?'
                                multiline
                                maxRows={4}
                                value={values.medicamentos || ''}
                                onChange={(e) => {
                                  if (e.target.value.length <= 300) handleChange(e);
                                }}
                                inputProps={{ maxLength: 300 }}
                                helperText={`${(values.medicamentos || '').length}/300 caracteres`}
                                    />
                            </Grid>
                          )}
                          <Grid item xs={12}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={values.pode_ir_sozinho}
                                  onChange={(e) => setFieldValue('pode_ir_sozinho', e.target.checked)}
                                  name='pode_ir_sozinho'
                                />
                              }
                              label='O aluno pode ir embora sozinho após as aulas?'
                            />
                          </Grid>
                        </Grid>
                        </AccordionDetails>
                      </Accordion>
                    )}

                    {/* Accordion 4: Contatos de Emergência e Autorizados */}
                    {showIJMFormMenor && (
                      <Accordion defaultExpanded sx={{ mb: 2 }}>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                          <Typography variant='h5' fontWeight='bold'>Contatos de Emergência e Autorizados</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <Typography variant='h6' fontWeight='bold'>Contatos de Emergência</Typography>
                            <Alert severity='info' sx={{ mt: 1, mb: 2 }}>
                              Informe até 3 pessoas de confiança para contato em
                              caso de emergência.
                            </Alert>
                          </Grid>

                          <Grid item xs={12}>
                            <ContatoCard
                              numero={1}
                              values={values}
                              handleChange={handleChange}
                              tipo='emergencia'
                              obrigatorio={true}
                            />
                            <ContatoCard
                              numero={2}
                              values={values}
                              handleChange={handleChange}
                              tipo='emergencia'
                            />
                            <ContatoCard
                              numero={3}
                              values={values}
                              handleChange={handleChange}
                              tipo='emergencia'
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <Divider sx={{ my: 2 }} />
                            <Typography variant='h6' fontWeight='bold'>Pessoas Autorizadas a Buscar</Typography>
                          </Grid>

                          <Grid item xs={12}>
                            <ContatoCard
                              numero={1}
                              values={values}
                              handleChange={handleChange}
                              tipo='autorizado'
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <ContatoCard
                              numero={2}
                              values={values}
                              handleChange={handleChange}
                              tipo='autorizado'
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <ContatoCard
                              numero={3}
                              values={values}
                              handleChange={handleChange}
                              tipo='autorizado'
                            />
                          </Grid>
                        </Grid>
                        </AccordionDetails>
                      </Accordion>
                    )}

                    {/* Accordion 5: Selecionar Turma */}
                    <Accordion defaultExpanded sx={{ mb: 2 }}>
                      <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography variant='h5' fontWeight='bold'>Selecionar Turma</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            {isEnrollmentBlocked && (
                              <Alert severity='error' sx={{ mb: 2 }}>
                                As matrículas para este curso estão bloqueadas no momento. Não é possível realizar novas inscrições.
                              </Alert>
                            )}
                            {classes.length === 0 ? (
                              <Alert severity='warning'>
                                Nenhuma turma disponível no momento para este curso. Entre em contato com a secretaria para mais informações.
                              </Alert>
                            ) : (
                              <FormControl>
                                <FormLabel
                                  sx={{ fontSize: '1.3rem', color: '#7352c7' }}
                                >
                                  Escolha uma das turmas disponíveis:
                                </FormLabel>
                                <RadioGroup
                                  name='turmas_id'
                                  value={values.turmas_id}
                                  onChange={handleChange}
                                >
                                  {classes.map((classe) => (
                                    <FormControlLabel
                                      key={classe.turmas_id}
                                      value={classe.turmas_id}
                                      control={<Radio />}
                                      label={`${classe.dia_da_semana} - ${classe.horario} - ${classe.modo}`}
                                    />
                                  ))}
                                </RadioGroup>
                              </FormControl>
                            )}
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    {/* Botão Submit */}
                    <Box sx={{ textAlign: 'center', mt: 2, mb: 2 }}>
                      <LoadingButton
                        color='success'
                        type='submit'
                        variant='contained'
                        size='large'
                        loading={isSubmitting}
                        sx={{ width: { xs: '100%', md: '200px' } }}
                      >
                        {precisaResponsavel
                          ? menorSelecionado
                            ? 'Atualizar menor e matricular'
                            : 'Cadastrar Menor'
                          : 'Finalizar Matrícula'}
                      </LoadingButton>
                    </Box>

                    {isSubmitting ? errorsHandler(errors) : null}
                    {verifyValidations(values)}
                  </Form>
                )}
              </Formik>
            )}
          </Paper>
        </>
      )}
    </JumboContentLayout>
  );
};

export default JoinCoursesIJMForm;
